// src/widgets/definitions/events/widgets.ts
var ro = /* @__PURE__ */ ((g) => {
  g["IMTBL_WIDGETS_PROVIDER"] = "imtbl-widgets-provider";
  g["IMTBL_CONNECT_WIDGET_EVENT"] = "imtbl-connect-widget";
  g["IMTBL_WALLET_WIDGET_EVENT"] = "imtbl-wallet-widget";
  g["IMTBL_SWAP_WIDGET_EVENT"] = "imtbl-swap-widget";
  g["IMTBL_BRIDGE_WIDGET_EVENT"] = "imtbl-bridge-widget";
  g["IMTBL_ONRAMP_WIDGET_EVENT"] = "imtbl-onramp-widget";
  g["IMTBL_SALE_WIDGET_EVENT"] = "imtbl-sale-widget";
  g["IMTBL_COMMERCE_WIDGET_EVENT"] = "imtbl-commerce-widget";
  g["IMTBL_ADD_TOKENS_WIDGET_EVENT"] = "imtbl-add-tokens-widget";
  g["IMTBL_PURCHASE_WIDGET_EVENT"] = "imtbl-purchase-widget";
  g["IMTBL_TRANSFER_WIDGET_EVENT"] = "imtbl-transfer-widget";
  return g;
})(ro || {});
var oo = /* @__PURE__ */ ((e) => {
  e["PROVIDER_UPDATED"] = "PROVIDER_UPDATED";
  return e;
})(oo || {});

// src/widgets/definitions/events/connect.ts
var no = /* @__PURE__ */ ((a) => {
  a["CLOSE_WIDGET"] = "close-widget";
  a["SUCCESS"] = "success";
  a["FAILURE"] = "failure";
  a["LANGUAGE_CHANGED"] = "language-changed";
  a["WALLETCONNECT_PROVIDER_UPDATED"] = "walletconnect-provider-updated";
  return a;
})(no || {});

// src/widgets/definitions/events/wallet.ts
var ao = /* @__PURE__ */ ((n) => {
  n["CLOSE_WIDGET"] = "close-widget";
  n["NETWORK_SWITCH"] = "network-switch";
  n["DISCONNECT_WALLET"] = "disconnect-wallet";
  n["LANGUAGE_CHANGED"] = "language-changed";
  return n;
})(ao || {});

// src/widgets/definitions/events/swap.ts
var io = /* @__PURE__ */ ((a) => {
  a["CLOSE_WIDGET"] = "close-widget";
  a["SUCCESS"] = "success";
  a["FAILURE"] = "failure";
  a["REJECTED"] = "rejected";
  a["LANGUAGE_CHANGED"] = "language-changed";
  return a;
})(io || {});

// src/widgets/definitions/events/sale.ts
var so = /* @__PURE__ */ ((g) => {
  g["CLOSE_WIDGET"] = "close-widget";
  g["SUCCESS"] = "success";
  g["FAILURE"] = "failure";
  g["REJECTED"] = "rejected";
  g["TRANSACTION_SUCCESS"] = "transaction-success";
  g["LANGUAGE_CHANGED"] = "language-changed";
  g["PAYMENT_METHOD"] = "payment-method";
  g["REQUEST_BRIDGE"] = "request-bridge";
  g["REQUEST_ONRAMP"] = "request-onramp";
  g["REQUEST_SWAP"] = "request-swap";
  g["PAYMENT_TOKEN"] = "payment-token";
  return g;
})(so || {});
var co = /* @__PURE__ */ ((o) => {
  o["CRYPTO"] = "crypto";
  o["DEBIT"] = "debit";
  o["CREDIT"] = "credit";
  return o;
})(co || {});

// src/widgets/definitions/events/bridge.ts
var lo = /* @__PURE__ */ ((i) => {
  i["CLOSE_WIDGET"] = "close-widget";
  i["FAILURE"] = "failure";
  i["TRANSACTION_SENT"] = "transaction-sent";
  i["LANGUAGE_CHANGED"] = "language-changed";
  i["CLAIM_WITHDRAWAL_SUCCESS"] = "claim-withdrawal-success";
  i["CLAIM_WITHDRAWAL_FAILURE"] = "claim-withdrawal-failure";
  return i;
})(lo || {});

// src/widgets/definitions/events/orchestration.ts
var po = /* @__PURE__ */ ((c) => {
  c["REQUEST_CONNECT"] = "request-connect";
  c["REQUEST_WALLET"] = "request-wallet";
  c["REQUEST_SWAP"] = "request-swap";
  c["REQUEST_BRIDGE"] = "request-bridge";
  c["REQUEST_ONRAMP"] = "request-onramp";
  c["REQUEST_ADD_TOKENS"] = "request-add-tokens";
  c["REQUEST_PURCHASE"] = "request-purchase";
  c["REQUEST_GO_BACK"] = "request-go-back";
  return c;
})(po || {});

// src/widgets/definitions/events/onramp.ts
var uo = /* @__PURE__ */ ((n) => {
  n["CLOSE_WIDGET"] = "close-widget";
  n["SUCCESS"] = "success";
  n["FAILURE"] = "failure";
  n["LANGUAGE_CHANGED"] = "language-changed";
  return n;
})(uo || {});

// src/widgets/definitions/events/commerce.ts
var mo = /* @__PURE__ */ ((s) => {
  s["INITIALISED"] = "INITIALISED";
  s["PROVIDER_UPDATED"] = "PROVIDER_UPDATED";
  s["CLOSE"] = "CLOSE";
  s["SUCCESS"] = "SUCCESS";
  s["FAILURE"] = "FAILURE";
  s["DISCONNECTED"] = "DISCONNECTED";
  s["USER_ACTION"] = "USER_ACTION";
  return s;
})(mo || {});
var go = /* @__PURE__ */ ((p) => {
  p["SWAP_SUCCESS"] = "SWAP_SUCCESS";
  p["ONRAMP_SUCCESS"] = "ONRAMP_SUCCESS";
  p["CONNECT_SUCCESS"] = "CONNECT_SUCCESS";
  p["SALE_SUCCESS"] = "SALE_SUCCESS";
  p["SALE_TRANSACTION_SUCCESS"] = "SALE_TRANSACTION_SUCCESS";
  p["BRIDGE_SUCCESS"] = "BRIDGE_SUCCESS";
  p["BRIDGE_CLAIM_WITHDRAWAL_SUCCESS"] = "BRIDGE_CLAIM_WITHDRAWAL_SUCCESS";
  p["ADD_TOKENS_SUCCESS"] = "ADD_TOKENS_SUCCESS";
  p["ADD_TOKENS_CONNECT_SUCCESS"] = "ADD_TOKENS_CONNECT_SUCCESS";
  return p;
})(go || {});
var fo = /* @__PURE__ */ ((c) => {
  c["BRIDGE_FAILED"] = "BRIDGE_FAILED";
  c["BRIDGE_CLAIM_WITHDRAWAL_FAILED"] = "BRIDGE_CLAIM_WITHDRAWAL_FAILED";
  c["SWAP_FAILED"] = "SWAP_FAILED";
  c["SWAP_REJECTED"] = "SWAP_REJECTED";
  c["CONNECT_FAILED"] = "CONNECT_FAILED";
  c["SALE_FAILED"] = "SALE_FAILED";
  c["ONRAMP_FAILED"] = "ONRAMP_FAILED";
  c["ADD_TOKENS_FAILED"] = "ADD_TOKENS_FAILED";
  return c;
})(fo || {});
var Eo = /* @__PURE__ */ ((o) => {
  o["PAYMENT_METHOD_SELECTED"] = "PAYMENT_METHOD_SELECTED";
  o["PAYMENT_TOKEN_SELECTED"] = "PAYMENT_TOKEN_SELECTED";
  o["NETWORK_SWITCH"] = "NETWORK_SWITCH";
  return o;
})(Eo || {});

// src/widgets/definitions/events/addTokens.ts
var Ro = /* @__PURE__ */ ((a) => {
  a["CLOSE_WIDGET"] = "close-widget";
  a["LANGUAGE_CHANGED"] = "language-changed";
  a["CONNECT_SUCCESS"] = "connect-success";
  a["SUCCESS"] = "success";
  a["FAILURE"] = "failure";
  return a;
})(Ro || {});

// src/widgets/definitions/events/purchase.ts
var Co = /* @__PURE__ */ ((n) => {
  n["CLOSE_WIDGET"] = "close-widget";
  n["CONNECT_SUCCESS"] = "connect-success";
  n["SUCCESS"] = "success";
  n["FAILURE"] = "failure";
  return n;
})(Co || {});

// src/widgets/definitions/events/transfer.ts
var To = /* @__PURE__ */ ((n) => {
  n["CLOSE_WIDGET"] = "close-widget";
  n["REJECTED"] = "rejected";
  n["SUCCESS"] = "success";
  n["FAILURE"] = "failure";
  return n;
})(To || {});

// src/widgets/definitions/types.ts
var Io = /* @__PURE__ */ ((u) => {
  u["CONNECT"] = "connect";
  u["WALLET"] = "wallet";
  u["SWAP"] = "swap";
  u["BRIDGE"] = "bridge";
  u["ONRAMP"] = "onramp";
  u["SALE"] = "sale";
  u["IMMUTABLE_COMMERCE"] = "immutableCommerce";
  u["ADD_TOKENS"] = "addTokens";
  u["PURCHASE"] = "purchase";
  u["TRANSFER"] = "transfer";
  return u;
})(Io || {});

// src/widgets/definitions/parameters/connect.ts
var ho = /* @__PURE__ */ ((t) => {
  t["LAYER1"] = "LAYER1";
  t["LAYER2"] = "LAYER2";
  return t;
})(ho || {});

// src/widgets/definitions/parameters/swap.ts
var yo = /* @__PURE__ */ ((t) => {
  t["FROM"] = "FROM";
  t["TO"] = "TO";
  return t;
})(yo || {});

// src/widgets/definitions/parameters/commerce.ts
var Ao = /* @__PURE__ */ ((p) => {
  p["CONNECT"] = "CONNECT";
  p["WALLET"] = "WALLET";
  p["SALE"] = "SALE";
  p["SWAP"] = "SWAP";
  p["BRIDGE"] = "BRIDGE";
  p["ONRAMP"] = "ONRAMP";
  p["ADD_TOKENS"] = "ADD_TOKENS";
  p["PURCHASE"] = "PURCHASE";
  p["TRANSFER"] = "TRANSFER";
  return p;
})(Ao || {});

// src/widgets/definitions/configurations/theme.ts
var wo = /* @__PURE__ */ ((t) => {
  t["LIGHT"] = "light";
  t["DARK"] = "dark";
  return t;
})(wo || {});

// src/sdk.ts
import { Environment as Va } from "@imtbl/config";

// src/api/http/httpClient.ts
import Po from "axios";
var So = "pk_imapik-";
var ko = [
  "https://checkout-api.dev.immutable.com",
  "https://checkout-api.sandbox.immutable.com",
  "https://checkout-api.immutable.com"
];
var ue = class {
  config;
  axiosInstance;
  constructor(e) {
    this.config = e;
    this.axiosInstance = Po.create();
    this.setupInterceptors();
  }
  // eslint-disable-next-line class-methods-use-this
  shouldAddPublishableKey(e) {
    return ko.some((t) => e.startsWith(t));
  }
  setupInterceptors() {
    this.axiosInstance.interceptors.request.use(
      (e) => {
        const t = this.config?.baseConfig?.publishableKey;
        if (t && this.shouldAddPublishableKey(e.url || "")) {
          if (!t.startsWith(So)) {
            throw new Error(
              "Invalid Publishable key. Create your Publishable key in Immutable developer hub. https://hub.immutable.com"
            );
          }
          e.headers["x-immutable-publishable-key"] = t;
        }
        return e;
      },
      (e) => Promise.reject(e)
    );
  }
  async request(e) {
    return await this.axiosInstance.request(e);
  }
  async get(e, t) {
    const o = {
      ...t,
      url: e
    };
    return await this.request(o);
  }
  async post(e, t, o) {
    const n = {
      ...o,
      data: t,
      url: e
    };
    return await this.request(n);
  }
  async put(e, t, o) {
    const n = {
      ...o,
      data: t,
      url: e
    };
    return await this.request(n);
  }
  async delete(e, t, o) {
    const n = {
      ...o,
      data: t,
      url: e
    };
    return await this.request(n);
  }
};

// src/availability/availability.ts
import { Environment as Ut } from "@imtbl/config";
import _o from "axios";

// src/errors/checkoutError.ts
var S = /* @__PURE__ */ ((A) => {
  A["MISSING_PARAMS"] = "MISSING_PARAMS";
  A["WEB3_PROVIDER_ERROR"] = "WEB3_PROVIDER_ERROR";
  A["PROVIDER_ERROR"] = "PROVIDER_ERROR";
  A["DEFAULT_PROVIDER_ERROR"] = "DEFAULT_PROVIDER_ERROR";
  A["CONNECT_PROVIDER_ERROR"] = "CONNECT_PROVIDER_ERROR";
  A["GET_BALANCE_ERROR"] = "GET_BALANCE_ERROR";
  A["GET_INDEXER_BALANCE_ERROR"] = "GET_INDEXER_BALANCE_ERROR";
  A["GET_ERC20_INFO_ERROR"] = "GET_ERC20_INFO_ERROR";
  A["GET_ERC20_BALANCE_ERROR"] = "GET_ERC20_BALANCE_ERROR";
  A["GET_ERC721_BALANCE_ERROR"] = "GET_ERC721_BALANCE_ERROR";
  A["GET_NETWORK_INFO_ERROR"] = "GET_NETWORK_INFO_ERROR";
  A["METAMASK_PROVIDER_ERROR"] = "METAMASK_PROVIDER_ERROR";
  A["CHAIN_NOT_SUPPORTED_ERROR"] = "CHAIN_NOT_SUPPORTED_ERROR";
  A["PROVIDER_REQUEST_MISSING_ERROR"] = "PROVIDER_REQUEST_MISSING_ERROR";
  A["PROVIDER_REQUEST_FAILED_ERROR"] = "PROVIDER_REQUEST_FAILED_ERROR";
  A["USER_REJECTED_REQUEST_ERROR"] = "USER_REJECTED_REQUEST_ERROR";
  A["TRANSACTION_FAILED"] = "TRANSACTION_FAILED";
  A["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
  A["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
  A["INVALID_GAS_ESTIMATE_TYPE"] = "INVALID_GAS_ESTIMATE_TYPE";
  A["UNSUPPORTED_TOKEN_TYPE_ERROR"] = "UNSUPPORTED_TOKEN_TYPE_ERROR";
  A["UNSUPPORTED_BALANCE_REQUIREMENT_ERROR"] = "UNSUPPORTED_BALANCE_REQUIREMENT_ERROR";
  A["GET_ORDER_LISTING_ERROR"] = "GET_ORDER_LISTING_ERROR";
  A["CANCEL_ORDER_LISTING_ERROR"] = "CANCEL_ORDER_LISTING_ERROR";
  A["PREPARE_ORDER_LISTING_ERROR"] = "PREPARE_ORDER_LISTING_ERROR";
  A["CREATE_ORDER_LISTING_ERROR"] = "CREATE_ORDER_LISTING_ERROR";
  A["FULFILL_ORDER_LISTING_ERROR"] = "FULFILL_ORDER_LISTING_ERROR";
  A["SWITCH_NETWORK_UNSUPPORTED"] = "SWITCH_NETWORK_UNSUPPORTED";
  A["GET_ERC20_ALLOWANCE_ERROR"] = "GET_ERC20_ALLOWANCE_ERROR";
  A["GET_ERC721_ALLOWANCE_ERROR"] = "GET_ERC721_ALLOWANCE_ERROR";
  A["GET_ERC1155_ALLOWANCE_ERROR"] = "GET_ERC1155_ALLOWANCE_ERROR";
  A["EXECUTE_APPROVAL_TRANSACTION_ERROR"] = "EXECUTE_APPROVAL_TRANSACTION_ERROR";
  A["EXECUTE_FULFILLMENT_TRANSACTION_ERROR"] = "EXECUTE_FULFILLMENT_TRANSACTION_ERROR";
  A["SIGN_MESSAGE_ERROR"] = "SIGN_MESSAGE_ERROR";
  A["BRIDGE_GAS_ESTIMATE_ERROR"] = "BRIDGE_GAS_ESTIMATE_ERROR";
  A["ORDER_FEE_ERROR"] = "ORDER_FEE_ERROR";
  A["ITEM_REQUIREMENTS_ERROR"] = "ITEM_REQUIREMENTS_ERROR";
  A["API_ERROR"] = "API_ERROR";
  A["ORDER_EXPIRED_ERROR"] = "ORDER_EXPIRED_ERROR";
  A["WIDGETS_SCRIPT_LOAD_ERROR"] = "WIDGETS_SCRIPT_LOAD_ERROR";
  A["APPROVAL_TRANSACTION_FAILED"] = "APPROVAL_TRANSACTION_FAILED";
  return A;
})(S || {});
var m = class extends Error {
  message;
  type;
  data;
  constructor(e, t, o) {
    super(e);
    this.message = e;
    this.type = t;
    this.data = o;
  }
};
var L = async (r, e) => {
  try {
    return await r();
  } catch (t) {
    const o = t?.error?.message ?? (t.message || "UnknownError");
    const n = e.message ? `[${e.type}]:${e.message}. Cause:${o}` : `[${e.type}] Cause:${o}`;
    if (t instanceof m) {
      throw new m(n, e.type, {
        ...e.data,
        innerErrorType: t.type,
        ...t.data
      });
    }
    throw new m(n, e.type, {
      ...e.data
    });
  }
};

// src/env/constants.ts
import { Environment as re } from "@imtbl/config";

// src/types/chains.ts
var Y = /* @__PURE__ */ ((a) => {
  a[a["IMTBL_ZKEVM_MAINNET"] = 13371] = "IMTBL_ZKEVM_MAINNET";
  a[a["IMTBL_ZKEVM_TESTNET"] = 13473] = "IMTBL_ZKEVM_TESTNET";
  a[a["IMTBL_ZKEVM_DEVNET"] = 15003] = "IMTBL_ZKEVM_DEVNET";
  a[a["ETHEREUM"] = 1] = "ETHEREUM";
  a[a["SEPOLIA"] = 11155111] = "SEPOLIA";
  return a;
})(Y || {});
var nt = /* @__PURE__ */ ((a) => {
  a["ETHEREUM"] = "Ethereum";
  a["SEPOLIA"] = "Sepolia";
  a["IMTBL_ZKEVM_TESTNET"] = "Immutable zkEVM Testnet";
  a["IMTBL_ZKEVM_DEVNET"] = "Immutable zkEVM Dev";
  a["IMTBL_ZKEVM_MAINNET"] = "Immutable zkEVM";
  return a;
})(nt || {});
var we = /* @__PURE__ */ ((a) => {
  a["ETHEREUM"] = "ethereum";
  a["SEPOLIA"] = "sepolia";
  a["IMTBL_ZKEVM_MAINNET"] = "imtbl-zkevm-mainnet";
  a["IMTBL_ZKEVM_TESTNET"] = "imtbl-zkevm-testnet";
  a["IMTBL_ZKEVM_DEVNET"] = "imtbl-zkevm-devnet";
  return a;
})(we || {});

// src/env/constants.ts
var J = "development";
var j = 18;
var Mt = 6;
var x = "native";
var ke = {
  name: "IMX",
  symbol: "IMX",
  decimals: j,
  address: x
};
var vo = {
  name: "tIMX",
  symbol: "tIMX",
  decimals: j,
  address: x
};
var q = {
  [J]: "https://api.dev.immutable.com",
  [re.SANDBOX]: "https://api.sandbox.immutable.com",
  [re.PRODUCTION]: "https://api.immutable.com"
};
var ve = {
  [J]: "https://checkout-api.dev.immutable.com",
  [re.SANDBOX]: "https://checkout-api.sandbox.immutable.com",
  [re.PRODUCTION]: "https://checkout-api.immutable.com"
};
var bt = true;
var Lt = true;
var Dt = true;
var Wt = {
  [re.SANDBOX]: "https://global-stg.transak.com",
  [re.PRODUCTION]: "https://global.transak.com/"
};
var Pe = /* @__PURE__ */ new Map([
  [
    1,
    {
      chainIdHex: `0x${1 .toString(16)}`,
      chainName: "Ethereum",
      rpcUrls: ["https://checkout-api.immutable.com/v1/rpc/eth-mainnet"],
      nativeCurrency: {
        name: "Ethereum",
        symbol: "ETH",
        decimals: 18
      },
      blockExplorerUrls: ["https://etherscan.io/"]
    }
  ],
  [
    13371,
    {
      chainIdHex: `0x${13371 .toString(16)}`,
      chainName: "Immutable zkEVM",
      rpcUrls: ["https://rpc.immutable.com"],
      nativeCurrency: ke
    }
  ]
]);
var Se = /* @__PURE__ */ new Map([
  [
    11155111,
    {
      chainIdHex: `0x${11155111 .toString(16)}`,
      chainName: "Sepolia",
      rpcUrls: [
        "https://checkout-api.sandbox.immutable.com/v1/rpc/eth-sepolia"
      ],
      nativeCurrency: {
        name: "Sep Eth",
        symbol: "ETH",
        decimals: 18
      },
      blockExplorerUrls: ["https://sepolia.etherscan.io/"]
    }
  ],
  [
    13473,
    {
      chainIdHex: `0x${13473 .toString(16)}`,
      chainName: "Immutable zkEVM Testnet",
      rpcUrls: ["https://rpc.testnet.immutable.com"],
      nativeCurrency: vo
    }
  ]
]);
var Ft = /* @__PURE__ */ new Map([
  [
    11155111,
    {
      chainIdHex: `0x${11155111 .toString(16)}`,
      chainName: "Sepolia",
      rpcUrls: ["https://checkout-api.dev.immutable.com/v1/rpc/eth-sepolia"],
      nativeCurrency: {
        name: "Sep Eth",
        symbol: "ETH",
        decimals: 18
      },
      blockExplorerUrls: ["https://sepolia.etherscan.io/"]
    }
  ],
  [
    15003,
    {
      chainIdHex: `0x${15003 .toString(16)}`,
      chainName: "Immutable zkEVM Dev",
      rpcUrls: ["https://rpc.dev.immutable.com"],
      nativeCurrency: ke
    }
  ]
]);
var oe = {
  [13473]: {
    url: "https://explorer.testnet.immutable.com",
    nativeToken: Se.get(13473).nativeCurrency
  },
  [13371]: {
    url: "https://explorer.immutable.com",
    nativeToken: Pe.get(13371).nativeCurrency
  },
  [11155111]: {
    url: "https://eth-sepolia.blockscout.com",
    nativeToken: Se.get(11155111).nativeCurrency
  },
  [1]: {
    url: "https://eth.blockscout.com/",
    nativeToken: Pe.get(1).nativeCurrency
  }
};
var W = [
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [
      {
        name: "",
        type: "uint8"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        name: "_owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        name: "balance",
        type: "uint256"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: false,
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        name: "_owner",
        type: "address"
      },
      {
        name: "_spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: false,
    inputs: [
      {
        name: "_spender",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  }
];
var ne = [
  {
    constant: false,
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    payable: false,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: true,
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var at = [
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];
var it = {
  maxFeePerGas: BigInt(15e9),
  maxPriorityFeePerGas: BigInt(1e10)
};

// src/env/env.ts
var No = "2.2.1-alpha.4";
var me = () => No;

// src/availability/availability.ts
var Ne = (r, e) => {
  const t = () => {
    if (r) return q[J];
    if (e) return q[Ut.PRODUCTION];
    return q[Ut.SANDBOX];
  };
  const o = async () => {
    let n;
    try {
      n = await _o.post(`${t()}/v1/availability/checkout/swap`);
    } catch (a) {
      n = a.response;
      if (n.status === 403) return false;
      throw new m(
        `Error fetching from api: ${n.status} ${n.statusText}`,
        "API_ERROR",
        { error: a }
      );
    }
    return true;
  };
  return {
    checkDexAvailability: o
  };
};

// src/balances/balances.ts
import { HttpStatusCode as ut } from "axios";
import { Contract as zo, formatUnits as gt } from "ethers";

// src/types/gasEstimate.ts
var st = /* @__PURE__ */ ((t) => {
  t["BRIDGE_TO_L2"] = "BRIDGE_TO_L2";
  t["SWAP"] = "SWAP";
  return t;
})(st || {});

// src/types/network.ts
var ge = /* @__PURE__ */ ((e) => {
  e["ALL"] = "all";
  return e;
})(ge || {});

// src/types/token.ts
var ae = /* @__PURE__ */ ((n) => {
  n["ALL"] = "all";
  n["SWAP"] = "swap";
  n["BRIDGE"] = "bridge";
  n["ONRAMP"] = "onramp";
  return n;
})(ae || {});

// src/types/wallet.ts
var Gt = /* @__PURE__ */ ((e) => {
  e["ALL"] = "all";
  return e;
})(Gt || {});

// src/types/provider.ts
import {
  BrowserProvider as Oo
} from "ethers";
var fe = /* @__PURE__ */ ((o) => {
  o["PASSPORT"] = "passport";
  o["METAMASK"] = "metamask";
  o["WALLETCONNECT"] = "walletconnect";
  return o;
})(fe || {});
var qt = /* @__PURE__ */ ((o) => {
  o["PASSPORT"] = "com.immutable.passport";
  o["METAMASK"] = "io.metamask";
  o["WALLETCONNECT"] = "walletconnect";
  return o;
})(qt || {});
var jt = {
  allowMistmatchedChainId: false,
  allowUnsupportedProvider: false
};
var D = class extends Oo {
  ethereumProvider;
  // eslint-disable-next-line max-len
  constructor(e, t, o) {
    super(e, t, o);
    this.#e(e);
  }
  #e(e) {
    if (!("request" in e) || typeof e.request !== "function") {
      return;
    }
    this.ethereumProvider = e;
  }
};

// src/types/smartCheckout.ts
var Ee = /* @__PURE__ */ ((n) => {
  n["SUCCESS"] = "SUCCESS";
  n["FAILED"] = "FAILED";
  n["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
  n["FULFILLMENTS_UNSETTLED"] = "FULFILLMENTS_UNSETTLED";
  return n;
})(Ee || {});
var M = /* @__PURE__ */ ((n) => {
  n["NATIVE"] = "NATIVE";
  n["ERC20"] = "ERC20";
  n["ERC721"] = "ERC721";
  n["ERC1155"] = "ERC1155";
  return n;
})(M || {});
var Re = /* @__PURE__ */ ((t) => {
  t["TRANSACTION"] = "TRANSACTION";
  t["GAS"] = "GAS";
  return t;
})(Re || {});
var Ce = /* @__PURE__ */ ((t) => {
  t["NATIVE"] = "NATIVE";
  t["ERC20"] = "ERC20";
  return t;
})(Ce || {});
var ct = /* @__PURE__ */ ((o) => {
  o["ROUTES_FOUND"] = "ROUTES_FOUND";
  o["NO_ROUTES_FOUND"] = "NO_ROUTES_FOUND";
  o["NO_ROUTE_OPTIONS"] = "NO_ROUTE_OPTIONS";
  return o;
})(ct || {});
var _e = /* @__PURE__ */ ((n) => {
  n["GAS"] = "GAS";
  n["BRIDGE_FEE"] = "BRIDGE_FEE";
  n["SWAP_FEE"] = "SWAP_FEE";
  n["IMMUTABLE_FEE"] = "IMMUTABLE_FEE";
  return n;
})(_e || {});
var Te = /* @__PURE__ */ ((o) => {
  o["BRIDGE"] = "BRIDGE";
  o["SWAP"] = "SWAP";
  o["ONRAMP"] = "ONRAMP";
  return o;
})(Te || {});

// src/types/fiatRamp.ts
var Vt = /* @__PURE__ */ ((e) => {
  e["ONRAMP"] = "onramp";
  return e;
})(Vt || {});

// src/provider/getUnderlyingProvider.ts
async function xo(r) {
  if (!r.send) {
    throw new m(
      "Parsed provider is not a valid WrappedBrowserProvider",
      "WEB3_PROVIDER_ERROR"
    );
  }
  const e = await r.send("eth_chainId", []);
  if (typeof e !== "bigint") {
    throw new m("Invalid chainId", "WEB3_PROVIDER_ERROR");
  }
  return e;
}
async function Ie(r) {
  const e = await r.getNetwork();
  if (e.chainId && typeof e.chainId === "bigint") {
    return e.chainId;
  }
  return xo(r);
}

// src/network/network.ts
var Bo = 4902;
async function Mo(r, e, t) {
  return await e.send("wallet_switchEthereumChain", [
    { chainId: r.get(t)?.chainIdHex }
  ]);
}
async function dt(r, e, t) {
  if (e.send) {
    const o = r.get(t);
    const n = {
      chainId: o?.chainIdHex,
      chainName: o?.chainName,
      rpcUrls: o?.rpcUrls,
      nativeCurrency: o?.nativeCurrency,
      blockExplorerUrls: o?.blockExplorerUrls
    };
    return await e.send("wallet_addEthereumChain", [n]);
  }
  return Promise.reject("Provider does not support request method");
}
async function $(r, { type: e = "all", exclude: t }) {
  const { networkMap: o } = r;
  const n = await r.remote.getConfig(
    "allowedNetworks"
  );
  if (!n) {
    console.warn("No allowed networks configured");
  }
  const a = (n || []).filter((s) => {
    const c = e === "all";
    const p = !(t || []).map((u) => u.chainId).includes(s.chainId);
    return c && p;
  });
  const i = [];
  a.forEach((s) => {
    const c = o.get(s.chainId);
    if (c) {
      i.push({
        name: c.chainName,
        chainId: parseInt(c.chainIdHex, 16),
        nativeCurrency: c.nativeCurrency,
        isSupported: true
      });
    }
  });
  return {
    networks: i
  };
}
async function he(r, e) {
  const { networkMap: t } = r;
  return L(
    async () => {
      try {
        const o = await e.getNetwork();
        if (Array.from(t.keys()).includes(Number(o.chainId))) {
          const n = t.get(Number(o.chainId));
          return {
            name: n.chainName,
            chainId: parseInt(n.chainIdHex, 16),
            nativeCurrency: n.nativeCurrency,
            isSupported: true
          };
        }
        return {
          chainId: Number(o.chainId),
          name: o.name,
          isSupported: false
        };
      } catch (o) {
        const n = await Ie(e);
        const a = Array.from(t.keys()).includes(Number(n));
        return {
          chainId: Number(n),
          isSupported: a
        };
      }
    },
    {
      type: "GET_NETWORK_INFO_ERROR"
    }
  );
}
var bo = (r) => r.error?.data?.originalError?.code === Bo;
async function Ht(r, e, t) {
  const { networkMap: o } = r;
  const n = await $(r, {
    type: "all"
  });
  if (!n.networks.some((c) => c.chainId === t)) {
    throw new m(
      `Chain:${t} is not a supported chain`,
      "CHAIN_NOT_SUPPORTED_ERROR"
    );
  }
  if (e.ethereumProvider?.isPassport) {
    throw new m(
      "Switching networks with Passport provider is not supported",
      "SWITCH_NETWORK_UNSUPPORTED"
    );
  }
  try {
    await Mo(o, e, t);
  } catch (c) {
    console.error(c);
    if (bo(c)) {
      try {
        await dt(o, e, t);
      } catch (p) {
        throw new m(
          "User cancelled add network request",
          "USER_REJECTED_REQUEST_ERROR",
          { error: p }
        );
      }
    } else {
      throw new m(
        "User cancelled switch network request",
        "USER_REJECTED_REQUEST_ERROR"
      );
    }
  }
  const a = new D(e.ethereumProvider);
  const i = await a.getNetwork();
  if (Number(i.chainId) !== t) {
    throw new m(
      "User cancelled switch network request",
      "USER_REJECTED_REQUEST_ERROR"
    );
  }
  const s = await he(r, a);
  return {
    network: s,
    provider: a
  };
}

// src/tokens/tokens.ts
import { Contract as jo } from "ethers";

// src/config/config.ts
import { Environment as ie } from "@imtbl/config";

// src/config/remoteConfigFetcher.ts
var Oe = class {
  httpClient;
  endpoint;
  configCache;
  version = "v1";
  constructor(e, t) {
    this.endpoint = t.remoteConfigEndpoint;
    this.httpClient = e;
  }
  // eslint-disable-next-line class-methods-use-this
  parseResponse(e) {
    let t = e.data;
    if (e.data && typeof e.data !== "object") {
      try {
        t = JSON.parse(e.data);
      } catch (o) {
        throw new m(
          "Invalid configuration",
          "API_ERROR",
          { error: o }
        );
      }
    }
    return t;
  }
  async loadConfig() {
    if (this.configCache) return this.configCache;
    let e;
    try {
      e = await this.httpClient.get(
        `${this.endpoint}/${this.version}/config`
      );
    } catch (t) {
      throw new m(
        `Error: ${t.message}`,
        "API_ERROR",
        { error: t }
      );
    }
    this.configCache = this.parseResponse(e);
    return this.configCache;
  }
  async getConfig(e) {
    const t = await this.loadConfig();
    if (!t) return void 0;
    if (!e) return t;
    return t[e];
  }
  getHttpClient = () => this.httpClient;
};

// src/config/tokensFetcher.ts
var Lo = "0x0000000000000000000000000000000000000eee";
var xe = class {
  httpClient;
  remoteConfig;
  baseUrl;
  chainSlug;
  tokensCache;
  constructor(e, t, o) {
    this.baseUrl = o.baseUrl;
    this.chainSlug = o.chainSlug;
    this.httpClient = e;
    this.remoteConfig = t;
  }
  async loadTokens() {
    if (this.tokensCache) {
      return this.tokensCache;
    }
    let e;
    try {
      e = await this.httpClient.get(
        `${this.baseUrl}/v1/chains/${this.chainSlug}/tokens?verification_status=verified&is_canonical=true`
      );
    } catch (o) {
      throw new m(
        `Error: ${o.message}`,
        "API_ERROR",
        { error: o }
      );
    }
    const t = this.parseResponse(e);
    this.tokensCache = await this.getMappingsForTokensResponse(
      t?.result || []
    );
    return this.tokensCache;
  }
  async getChainTokensConfig() {
    const e = await this.loadTokens();
    return e ?? {};
  }
  async getTokensConfig(e) {
    const t = await this.loadTokens();
    if (!t || !t[e]) return [];
    return t[e] ?? [];
  }
  async getMappingsForTokensResponse(e) {
    const t = {};
    const o = await this.fetchIMXTokenMappings();
    Object.keys(o).forEach((n) => {
      const a = parseInt(n, 10);
      t[a] = [];
      t[a]?.push({
        address: o[n],
        decimals: 18,
        name: "IMX",
        symbol: "IMX",
        bridge: "native"
      });
    });
    e.forEach((n) => {
      const a = parseInt(
        n.chain.id.split("eip155:").pop() || "",
        10
      );
      if (!n.symbol || !n.decimals) {
        return;
      }
      if (!t[a]) {
        t[a] = [];
      }
      const i = {
        address: n.contract_address.toLowerCase(),
        decimals: n.decimals,
        name: n.name,
        symbol: n.symbol,
        icon: n.image_url ?? void 0,
        bridge: n.bridge_used ?? null
      };
      t[a]?.push(i);
      const s = parseInt(
        n.root_chain_id?.split("eip155:").pop() || "",
        10
      );
      let c = n.root_contract_address?.toLowerCase();
      if (s && c) {
        if (!t[s]) {
          t[s] = [];
        }
        if (c === Lo) {
          c = "native";
        }
        t[s]?.push({
          ...i,
          address: c
        });
      }
    });
    return t;
  }
  // eslint-disable-next-line class-methods-use-this
  parseResponse(e) {
    let t = e.data;
    if (e.data && typeof e.data !== "object") {
      try {
        t = JSON.parse(e.data);
      } catch (o) {
        throw new m(
          "Invalid token data",
          "API_ERROR",
          { error: o }
        );
      }
    }
    return t;
  }
  async fetchIMXTokenMappings() {
    return await this.remoteConfig.getConfig(
      "imxAddressMapping"
    );
  }
};

// src/config/config.ts
var lt = class extends Error {
  message;
  constructor(e) {
    super(e);
    this.message = e;
  }
};
var Do = (r, e) => {
  if (e) return Ft;
  if (r) return Pe;
  return Se;
};
var Wo = (r, e) => {
  if (e) return q[J];
  if (r) return q[ie.PRODUCTION];
  return q[ie.SANDBOX];
};
var Fo = (r, e) => {
  if (e) return "imtbl-zkevm-devnet";
  if (r) return "imtbl-zkevm-mainnet";
  return "imtbl-zkevm-testnet";
};
var _ = (r) => {
  if (!r.isProduction) return 11155111;
  return 1;
};
var w = (r) => {
  if (r.isDevelopment) return 15003;
  if (r.isProduction) return 13371;
  return 13473;
};
var Uo = (r, e) => {
  if (e) return ve[J];
  if (r) return ve[ie.PRODUCTION];
  return ve[ie.SANDBOX];
};
var ye = class {
  // This is a hidden feature that is only available
  // when building the project from source code.
  // This will be used to get around the lack of
  // Environment.DEVELOPMENT
  isDevelopment = false;
  isProduction;
  isOnRampEnabled;
  isSwapEnabled;
  isBridgeEnabled;
  remote;
  tokens;
  environment;
  networkMap;
  publishableKey;
  l1ChainId;
  l2ChainId;
  overrides;
  constructor(e, t) {
    if (!Object.values(ie).includes(e.baseConfig.environment)) {
      throw new lt(
        "Invalid checkout configuration of environment"
      );
    }
    this.environment = e.baseConfig.environment;
    this.isProduction = !this.isDevelopment && this.environment === ie.PRODUCTION;
    this.isOnRampEnabled = e.onRamp?.enable ?? bt;
    this.isSwapEnabled = e.swap?.enable ?? Lt;
    this.isBridgeEnabled = e.bridge?.enable ?? Dt;
    this.publishableKey = e.publishableKey ?? "<no-publishable-key>";
    this.networkMap = e.overrides?.networkMap ?? Do(this.isProduction, this.isDevelopment);
    const o = e.overrides?.remoteConfigEndpoint ?? Uo(this.isProduction, this.isDevelopment);
    this.remote = new Oe(t, {
      remoteConfigEndpoint: o
    });
    this.tokens = new xe(t, this.remote, {
      baseUrl: e.overrides?.baseUrl ?? Wo(this.isProduction, this.isDevelopment),
      chainSlug: e.overrides?.chainSlug ?? Fo(this.isProduction, this.isDevelopment)
    });
    this.l1ChainId = _(this);
    this.l2ChainId = e.overrides?.l2ChainId ?? w(this);
    this.overrides = e.overrides ?? {};
  }
  // eslint-disable-next-line class-methods-use-this
  get sdkVersion() {
    return me();
  }
};

// src/utils/utils.ts
var h = (r = "", e = "") => r.toLowerCase() === e.toLowerCase();
var Qt = (r) => r === 15003 || r === 13473 || r === 13371;
var Go = (r, e) => {
  const t = r.indexOf(".");
  const o = r.substring(t + e + 1);
  if (o && parseFloat(o) >= 1) {
    const n = r.substring(0, t + e + 1);
    const a = 1 / 10 ** e;
    return (parseFloat(n) + a).toString();
  }
  return parseFloat(r.substring(0, t + e + 1)).toString();
};
var Z = (r, e = Mt) => {
  const t = r.indexOf(".");
  if (t === -1) return r;
  const o = Go(r, e);
  return o;
};

// src/tokens/tokens.ts
var Vo = "native";
var z = async (r, {
  type: e = "all",
  chainId: t,
  exclude: o
}) => {
  let n = [];
  let a;
  let i;
  const s = t ?? _(r);
  const c = w(r);
  switch (e) {
    case "swap":
      n = await r.tokens.getTokensConfig(c);
      i = ((await r.remote.getConfig("dex"))?.blocklist || []).map((p) => p.address.toLowerCase());
      n = n.filter((p) => p.address && !i.includes(p.address));
      break;
    case "onramp":
      a = await r.remote.getConfig("onramp");
      if (!a) n = [];
      n = a["201811419111"]?.tokens || [];
      break;
    case "bridge":
      n = (await r.tokens.getTokensConfig(s)).filter((p) => p.bridge === Vo);
      break;
    case "all":
    default:
      n = await r.tokens.getTokensConfig(s);
  }
  if (!o || o?.length === 0) return { tokens: n };
  return {
    tokens: n.filter((p) => !o.map((u) => u.address).includes(p.address || ""))
  };
};
var B = (r) => !r || h(r, x);
async function Be(r, e) {
  return await L(
    async () => {
      const t = new jo(e, JSON.stringify(W), r);
      const [o, n, a] = await Promise.all([
        t.name(),
        t.symbol(),
        t.decimals()
      ]);
      return {
        name: o,
        symbol: n,
        decimals: a,
        address: e
      };
    },
    { type: "GET_ERC20_INFO_ERROR" }
  );
}

// src/api/blockscout/blockscout.ts
import Zt, {
  HttpStatusCode as Yt
} from "axios";
var Ho = 5;
var Ae = class {
  url;
  nativeToken;
  ttl;
  chainId;
  cacheMap;
  httpClient;
  setCache(e, t) {
    this.cacheMap[e] = { data: t, ttl: (/* @__PURE__ */ new Date()).getTime() + this.ttl * 1e3 };
  }
  getCache(e) {
    const t = this.cacheMap[e];
    if (!t || t.ttl <= (/* @__PURE__ */ new Date()).getTime()) return null;
    return t.data;
  }
  /**
   * Blockscout constructor
   * @param httpClient Client used for http requests
   * @param chainId target chain
   * @param ttl cache TTL
   */
  constructor(e, t, o) {
    this.httpClient = e;
    this.chainId = t;
    this.url = oe[this.chainId].url;
    const n = oe[this.chainId].nativeToken;
    this.nativeToken = {
      address: n.address ?? "",
      decimals: n.decimals.toString(),
      name: n.name,
      symbol: n.symbol
    };
    this.cacheMap = {};
    this.ttl = o !== void 0 ? o : Ho;
  }
  /**
   * isChainSupported verifies if the chain is supported by Blockscout
   * @param chainId
   */
  static isChainSupported = (e) => Boolean(oe[e]);
  /**
   * isBlockscoutError verifies if the error is a Blockscout client error
   * @param err error to evaluate
   */
  static isBlockscoutError = (e) => "code" in e;
  /**
   * getTokensByWalletAddress fetches the list of tokens (by type) owned by the wallet address.
   * @param walletAddress wallet address
   * @param tokenType token type
   * @param nextPage parameters for the next page, to be provided alongside walletAddress and tokenType
   * @returns list of tokens given the wallet address and the token types
   */
  async getTokensByWalletAddress(e) {
    try {
      let t = `${this.url}/api/v2/addresses/${e.walletAddress}/tokens?type=${e.tokenType}`;
      if (e.nextPage) t += `&${new URLSearchParams(e.nextPage)}`;
      const o = this.getCache(t);
      if (o) return Promise.resolve(o);
      const n = await this.httpClient.get(t);
      const a = {
        items: n.data?.items?.filter(
          (i) => i.token.address && i.token.address !== this.nativeToken.address
        ),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        next_page_params: n.data?.next_page_params
      };
      this.setCache(t, a);
      return Promise.resolve(a);
    } catch (t) {
      let o = Yt.InternalServerError;
      let n = "InternalServerError";
      if (Zt.isAxiosError(t)) {
        o = t.response?.status || o;
        n = t.message;
      }
      return Promise.reject({ code: o, message: n });
    }
  }
  /**
   * getNativeTokenByWalletAddress fetches the native token owned by the wallet address.
   * @param walletAddress wallet address
   * @returns list of tokens given the wallet address and the token types
   */
  async getNativeTokenByWalletAddress(e) {
    try {
      const t = `${this.url}/api/v2/addresses/${e.walletAddress}`;
      const o = this.getCache(t);
      if (o) return Promise.resolve(o);
      const n = await this.httpClient.get(t);
      const a = {
        token: this.nativeToken,
        value: n.data.coin_balance
      };
      this.setCache(t, a);
      return Promise.resolve(a);
    } catch (t) {
      let o = Yt.InternalServerError;
      let n = "InternalServerError";
      if (Zt.isAxiosError(t)) {
        o = t.response?.status || o;
        n = t.message;
      }
      return Promise.reject({ code: o, message: n });
    }
  }
};

// src/logger/debugLogger.ts
var pt = (r, e, t) => {
  if (!r.isProduction) console.info(e, t);
};
var k = async (r, e, t) => {
  const o = performance.now();
  const n = await t;
  const a = performance.now();
  const i = (a - o) / 1e3;
  pt(r, e, i);
  return n;
};

// src/balances/balances.ts
var ft = async (r, e, t) => await L(
  async () => {
    const o = await he(r, e);
    if (!o.isSupported) {
      throw new m(
        `Chain:${o.chainId} is not a supported chain`,
        "CHAIN_NOT_SUPPORTED_ERROR",
        { chainName: o.name }
      );
    }
    const n = await e.getBalance(t);
    return {
      balance: n,
      formattedBalance: gt(
        n,
        o.nativeCurrency.decimals
      ),
      token: o.nativeCurrency
    };
  },
  { type: "GET_BALANCE_ERROR" }
);
async function Et(r, e, t) {
  return await L(
    async () => {
      const o = new zo(
        t,
        JSON.stringify(W),
        r
      );
      return Promise.all([
        Be(r, t),
        o.balanceOf(e)
      ]).then(([n, a]) => {
        const i = gt(a, n.decimals);
        return {
          balance: a,
          formattedBalance: i,
          token: {
            name: n.name,
            symbol: n.symbol,
            decimals: n.decimals,
            address: t
          }
        };
      });
    },
    { type: "GET_ERC20_BALANCE_ERROR" }
  );
}
var mt = /* @__PURE__ */ new Map();
var Rt = () => mt.clear();
var Qo = async (r, e, t, o) => {
  const n = o !== void 0;
  const a = Object.assign(
    {},
    ...(o ?? []).map((f) => ({ [f.address?.toLowerCase() || x]: f }))
  );
  let i = mt.get(t);
  if (!i) {
    const f = r.remote.getHttpClient();
    i = new Ae(f, t);
    mt.set(t, i);
  }
  const s = [];
  const c = "ERC-20";
  const p = async (f) => {
    let R;
    try {
      do {
        R = await f.getTokensByWalletAddress({
          walletAddress: e,
          tokenType: c,
          nextPage: R?.next_page_params
        });
        s.push(...R.items);
      } while (R.next_page_params);
    } catch (C) {
      if (C?.code !== ut.NotFound) {
        throw new m(
          C.message || "InternalServerError | getTokensByWalletAddress",
          "GET_INDEXER_BALANCE_ERROR",
          { error: C }
        );
      }
    }
  };
  const u = async (f) => {
    try {
      const R = await f.getNativeTokenByWalletAddress({ walletAddress: e });
      R.token.address ||= x;
      s.push(R);
    } catch (R) {
      if (R?.code !== ut.NotFound) {
        throw new m(
          R.message || "InternalServerError | getNativeTokenByWalletAddress",
          "GET_INDEXER_BALANCE_ERROR",
          { error: R }
        );
      }
    }
  };
  await Promise.all([
    p(i),
    u(i)
  ]);
  const g = [];
  s.forEach((f) => {
    const R = a[f.token.address.toLowerCase()];
    if (n && !R) return;
    const C = f.token || {};
    if (f.value == null) return;
    const E = BigInt(f.value);
    let T = parseInt(C.decimals, 10);
    if (Number.isNaN(T)) T = j;
    const y = C.icon_url ?? R.icon;
    const I = {
      ...C,
      decimals: T,
      icon: y
    };
    const P = gt(f.value, I.decimals);
    g.push({ balance: E, formattedBalance: P, token: I });
  });
  return { balances: g };
};
var Zo = async (r, e, t, o) => {
  const n = [];
  o.forEach((i) => {
    if (!i.address || h(i.address, x)) {
      n.push(
        ft(r, e, t)
      );
    } else {
      n.push(
        Et(e, t, i.address)
      );
    }
  });
  const a = await Promise.allSettled(n);
  return a.reduce((i, s) => {
    if (s.status !== "fulfilled" || s.value.balance === 0n) return i;
    const { value: c } = s;
    if (!c.token.address || h(c.token.address, x)) {
      c.token.address = x;
    }
    i.balances.push(c);
    return i;
  }, { balances: new Array() });
};
var Jt = async (r, e, t, o, n) => {
  if (!e) {
    throw new m(
      "indexer is disabled for this chain, you must provide a provider.",
      "MISSING_PARAMS"
    );
  }
  let a = t;
  if (!a) a = await (await e.getSigner()).getAddress();
  return await k(
    r,
    `Time to fetch balances using RPC for ${o}`,
    Zo(r, e, a, n)
  );
};
var V = async (r, e, t, o, n = false) => {
  if (!t && !e) {
    throw new m(
      "both walletAddress and provider are missing. At least one must be provided.",
      "MISSING_PARAMS"
    );
  }
  if (!r.networkMap.get(o)) {
    throw new m(
      `chain ID ${o} not supported by the environment`,
      "CHAIN_NOT_SUPPORTED_ERROR"
    );
  }
  const { tokens: a } = await z(
    r,
    {
      type: "all",
      chainId: o
    }
  );
  if (n) {
    Rt();
  }
  if (Ae.isChainSupported(o)) {
    const i = t ?? await (await e?.getSigner())?.getAddress();
    try {
      return await k(
        r,
        `Time to fetch balances using blockscout for ${o}`,
        Qo(r, i, o, a)
      );
    } catch (s) {
      if (s.type === "GET_INDEXER_BALANCE_ERROR" && s.data?.error?.code === ut.TooManyRequests) {
        return Jt(r, e, t, o, a);
      }
      throw s;
    }
  }
  return Jt(r, e, t, o, a);
};

// src/connect/connect.ts
async function $t(r) {
  if (!r?.send) {
    throw new m(
      "Check wallet connection request failed",
      "PROVIDER_REQUEST_FAILED_ERROR",
      {
        rpcMethod: "eth_accounts"
      }
    );
  }
  let e = [];
  try {
    e = await r.send("eth_accounts", []);
  } catch (t) {
    throw new m(
      "Check wallet connection request failed",
      "PROVIDER_REQUEST_FAILED_ERROR",
      {
        error: t,
        rpcMethod: "eth_accounts"
      }
    );
  }
  return {
    isConnected: e && e.length > 0,
    walletAddress: e[0] ?? ""
  };
}
async function Xt(r) {
  if (!r || !r.send) {
    throw new m(
      "Incompatible provider",
      "PROVIDER_REQUEST_MISSING_ERROR",
      { details: "Attempting to connect with an incompatible provider" }
    );
  }
  await L(
    async () => {
      if (!r.send) return;
      await r.send("eth_requestAccounts", []);
    },
    { type: "USER_REJECTED_REQUEST_ERROR" }
  );
  return r;
}
async function er(r) {
  if (!r || !r.send) {
    throw new m(
      "Incompatible provider",
      "PROVIDER_REQUEST_MISSING_ERROR",
      { details: "Attempting to connect with an incompatible provider" }
    );
  }
  await L(
    async () => {
      if (!r.send) return;
      await r.send("wallet_requestPermissions", [{ eth_accounts: {} }]);
    },
    { type: "USER_REJECTED_REQUEST_ERROR" }
  );
  return r;
}

// src/fiatRamp/fiatRamp.ts
var Me = class {
  config;
  /**
   * Constructs a new instance of the FiatRampService class.
   * @param {CheckoutConfiguration} config - The config required for the FiatRampService.
   */
  constructor(e) {
    this.config = e;
  }
  async feeEstimate() {
    const e = await this.config.remote.getConfig(
      "onramp"
    );
    return e["201811419111"]?.fees;
  }
  async createWidgetUrl(e) {
    return await this.getTransakWidgetUrl(e);
  }
  async getTransakWidgetUrl(e) {
    const t = await this.config.remote.getConfig(
      "onramp"
    );
    const o = Wt[this.config.environment];
    let n = {
      apiKey: t["201811419111"].publishableApiKey,
      network: "immutablezkevm",
      defaultPaymentMethod: "credit_debit_card",
      disablePaymentMethods: "",
      productsAvailed: "buy",
      exchangeScreenTitle: "Buy",
      themeColor: "0D0D0D",
      defaultCryptoCurrency: e.tokenSymbol || "IMX"
    };
    if (e.isPassport && e.email) {
      n = {
        ...n,
        email: encodeURIComponent(e.email),
        isAutoFillUserData: true,
        disableWalletAddressForm: true
      };
    }
    if (e.tokenAmount && e.tokenSymbol) {
      n = {
        ...n,
        defaultCryptoAmount: e.tokenAmount,
        cryptoCurrencyCode: e.tokenSymbol
      };
    } else {
      n = {
        ...n,
        defaultFiatAmount: 50,
        defaultFiatCurrency: "usd"
      };
    }
    if (e.walletAddress) {
      n = {
        ...n,
        walletAddress: e.walletAddress
      };
    }
    if (e.allowedTokens) {
      n = {
        ...n,
        cryptoCurrencyList: e.allowedTokens?.join(",").toLowerCase()
      };
    }
    return `${o}?${new URLSearchParams(n).toString()}`;
  }
};

// src/gasEstimate/gasEstimator.ts
import { parseUnits as cn } from "ethers";

// src/gasEstimate/bridgeGasEstimate.ts
import {
  BridgeFeeActions as tr
} from "@imtbl/bridge-sdk";
async function rr(r, e, t, o) {
  const n = e === _(o) ? tr.DEPOSIT : tr.WITHDRAW;
  return await r.getFee({
    action: n,
    gasMultiplier: "auto",
    sourceChainId: e.toString(),
    destinationChainId: t.toString(),
    token: x.toUpperCase(),
    amount: BigInt(0)
  });
}

// src/instance/instance.ts
import {
  BridgeConfiguration as $o,
  ETH_MAINNET_TO_ZKEVM_MAINNET as Xo,
  ETH_SEPOLIA_TO_ZKEVM_DEVNET as en,
  ETH_SEPOLIA_TO_ZKEVM_TESTNET as tn,
  TokenBridge as rn
} from "@imtbl/bridge-sdk";
import { ImmutableConfiguration as or } from "@imtbl/config";
import { Exchange as on } from "@imtbl/dex-sdk";
import { Orderbook as nn } from "@imtbl/orderbook";
import { BlockchainData as an } from "@imtbl/blockchain-data";
function be(r, e, t, o) {
  const n = t.get(r);
  const a = t.get(e);
  if (!n) {
    throw new m(
      `Chain:${r} is not a supported chain`,
      "CHAIN_NOT_SUPPORTED_ERROR"
    );
  }
  if (!a) {
    throw new m(
      `Chain:${e} is not a supported chain`,
      "CHAIN_NOT_SUPPORTED_ERROR"
    );
  }
  let i = tn;
  if (o.isDevelopment) i = en;
  if (o.isProduction) i = Xo;
  const s = new $o({
    baseConfig: new or({ environment: o.environment }),
    bridgeInstance: i,
    rootProvider: n,
    childProvider: a
  });
  return new rn(s);
}
async function se(r, e) {
  const t = await e.remote.getConfig(
    "dex"
  );
  return new on({
    chainId: r,
    baseConfig: new or({
      environment: e.environment
    }),
    overrides: t?.overrides,
    secondaryFees: t?.secondaryFees
  });
}
function ce(r) {
  return new nn({
    baseConfig: {
      environment: r.environment
    }
  });
}
function Le(r) {
  return new an({
    baseConfig: {
      environment: r.environment
    }
  });
}

// src/instance/contract.ts
import {
  Contract as sn
} from "ethers";
function nr(r, e, t) {
  return new sn(r, e, t);
}

// src/gasEstimate/gasEstimator.ts
var dn = "0x0000000000000000000000000000000000000001";
var ar = 18;
async function ln(r, e) {
  const t = _(e);
  const o = w(e);
  const n = r.get(t);
  if (!n) throw new Error(`Missing JsonRpcProvider for chain id: ${t}`);
  try {
    const a = be(
      t,
      o,
      r,
      e
    );
    const i = await rr(
      a,
      t,
      o,
      e
    );
    return {
      gasEstimateType: "BRIDGE_TO_L2",
      fees: i,
      token: e.networkMap.get(t)?.nativeCurrency
    };
  } catch {
    return {
      gasEstimateType: "BRIDGE_TO_L2",
      fees: {
        sourceChainGas: BigInt(0),
        approvalFee: BigInt(0),
        bridgeFee: BigInt(0),
        imtblFee: BigInt(0),
        totalFees: BigInt(0)
      },
      token: e.networkMap.get(t)?.nativeCurrency
    };
  }
}
async function pn(r) {
  const e = w(r);
  const t = await r.remote.getConfig(
    "gasEstimateTokens"
  );
  const { inAddress: o, outAddress: n } = t[e].swapAddresses;
  try {
    const a = await se(e, r);
    const { swap: i } = await a.getUnsignedSwapTxFromAmountIn(
      dn,
      o,
      n,
      BigInt(cn("1", ar))
    );
    if (!i.gasFeeEstimate) {
      return {
        gasEstimateType: "SWAP",
        fees: {}
      };
    }
    return {
      gasEstimateType: "SWAP",
      fees: {
        totalFees: i.gasFeeEstimate.value ? BigInt(i.gasFeeEstimate.value) : void 0,
        token: {
          address: i.gasFeeEstimate.token.address,
          symbol: i.gasFeeEstimate.token.symbol ?? "",
          name: i.gasFeeEstimate.token.name ?? "",
          decimals: i.gasFeeEstimate.token.decimals ?? ar
        }
      }
    };
  } catch {
    return {
      gasEstimateType: "SWAP",
      fees: {}
    };
  }
}
async function ir(r, e, t) {
  switch (r.gasEstimateType) {
    case "BRIDGE_TO_L2":
      return await ln(
        e,
        t
      );
    case "SWAP":
      return await pn(t);
    default:
      throw new m(
        "Invalid type provided for gasEstimateType",
        "INVALID_GAS_ESTIMATE_TYPE"
      );
  }
}

// src/gasEstimate/gasPriceInWei.ts
var un = (r) => !!r.maxFeePerGas && !!r.maxPriorityFeePerGas;
var Ct = (r) => {
  if (un(r)) {
    const { maxFeePerGas: e, maxPriorityFeePerGas: t } = r;
    if (e === null || t === null) return null;
    const o = (e - t) / BigInt(2);
    return t + o;
  }
  if (r.gasPrice) return r.gasPrice;
  return null;
};

// src/provider/provider.ts
import En from "@metamask/detect-provider";

// src/provider/injected/utils.ts
function Tt(r) {
  if (typeof window === "undefined") return;
  const e = (t) => r(t.detail);
  window.addEventListener("eip6963:announceProvider", e);
  window.dispatchEvent(new CustomEvent("eip6963:requestProvider"));
  return () => window.removeEventListener("eip6963:announceProvider", e);
}

// src/provider/injected/store.ts
function It() {
  const r = /* @__PURE__ */ new Set();
  let e = [];
  const t = () => Tt((n) => {
    if (e.some(
      ({ info: a }) => a.uuid === n.info.uuid
    )) return;
    e = [...e, n];
    r.forEach((a) => a(e, { added: [n] }));
  });
  let o = t();
  return {
    // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle
    _listeners() {
      return r;
    },
    clear() {
      r.forEach((n) => n([], { removed: [...e] }));
      e = [];
    },
    destroy() {
      this.clear();
      r.clear();
      o?.();
    },
    findProvider({ rdns: n }) {
      return e.find(
        (a) => a.info.rdns === n
      );
    },
    getProviders() {
      return e;
    },
    reset() {
      this.clear();
      o?.();
      o = t();
    },
    subscribe(n, { emitImmediately: a } = {}) {
      r.add(n);
      if (a) n(e, { added: e });
      return () => r.delete(n);
    }
  };
}

// src/provider/injectedProvidersManager.ts
var F = class r {
  static instance;
  store;
  resetTimeout;
  isInit = false;
  constructor() {
    this.store = It();
    this.store.reset();
  }
  static getInstance() {
    if (!r.instance) {
      r.instance = new r();
    }
    return r.instance;
  }
  findProvider(e) {
    return this.store.findProvider(e);
  }
  getProviders() {
    return this.store.getProviders();
  }
  subscribe(e) {
    return this.store.subscribe(e);
  }
  clear() {
    this.store.clear();
  }
  reset() {
    clearTimeout(this.resetTimeout);
    this.resetTimeout = setTimeout(() => {
      this.store.reset();
    }, 200);
  }
  initialise() {
    if (!this.isInit) {
      this.isInit = true;
      this.reset();
    }
  }
  // eslint-disable-next-line class-methods-use-this
  requestProviders() {
    window.dispatchEvent(new CustomEvent("eip6963:requestProvider"));
  }
  destroy() {
    this.store.destroy();
  }
};

// src/provider/providerDetail.ts
var De = {
  name: "MetaMask",
  rdns: "io.metamask",
  // eslint-disable-next-line max-len
  icon: "data:image/svg+xml;base64,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",
  uuid: "fb8e904e-1a71-454a-af65-dc1ee86311c3"
};
var We = {
  // eslint-disable-next-line max-len
  icon: 'data:image/svg+xml,<svg viewBox="0 0 48 48" class="SvgIcon undefined Logo Logo--PassportSymbolOutlined css-1dn9atd" xmlns="http://www.w3.org/2000/svg"><g data-testid="undefined__g"><circle cx="24" cy="24" r="22.5" fill="url(%23paint0_radial_6324_83922)"></circle><circle cx="24" cy="24" r="22.5" fill="url(%23paint1_radial_6324_83922)"></circle><path d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM23.0718 9.16608C23.7383 8.83951 24.4406 8.86188 25.087 9.2287C27.3282 10.5059 29.5627 11.7942 31.786 13.096C32.5018 13.5165 32.8686 14.1897 32.8708 15.0173C32.8843 17.9184 32.8798 20.8171 32.8708 23.7182C32.8708 23.8255 32.8015 23.9821 32.7143 24.0335C31.8531 24.548 30.9808 25.0423 30.0347 25.5881V25.1318C30.0347 22.148 30.0257 19.1664 30.0414 16.1827C30.0436 15.6101 29.8468 15.241 29.339 14.9525C26.7377 13.474 24.1499 11.9687 21.5575 10.4723C21.4457 10.4075 21.3361 10.3381 21.1661 10.2352C21.8326 9.85722 22.4321 9.47698 23.0673 9.16608H23.0718ZM22.5953 38.8451C22.45 38.7713 22.3426 38.7198 22.2375 38.6595C18.8041 36.68 15.3752 34.687 11.9307 32.7232C10.9644 32.173 10.5238 31.3879 10.5349 30.2852C10.5551 27.9411 10.5484 25.597 10.5372 23.2507C10.5327 22.1927 10.9622 21.4255 11.8926 20.8977C14.3105 19.5221 16.715 18.1264 19.1195 16.7284C19.3275 16.6076 19.4796 16.5875 19.6965 16.7172C20.5264 17.216 21.3719 17.6924 22.2554 18.2024C22.0876 18.3031 21.9601 18.3791 21.8304 18.4552C19.2268 19.9582 16.6278 21.4658 14.0175 22.9599C13.5903 23.2037 13.3912 23.5213 13.3957 24.0179C13.4091 25.8654 13.4114 27.713 13.3957 29.5605C13.3912 30.0705 13.5948 30.3948 14.0332 30.6453C16.7866 32.2199 19.5288 33.8125 22.28 35.3916C22.5126 35.5258 22.611 35.6645 22.6065 35.9418C22.5864 36.888 22.5998 37.8363 22.5998 38.8473L22.5953 38.8451ZM22.5953 33.553C22.356 33.4166 22.1838 33.3204 22.0116 33.2198C19.8285 31.9605 17.6477 30.6967 15.4602 29.4464C15.2231 29.3122 15.1359 29.1668 15.1381 28.8917C15.1538 27.4714 15.1471 26.0511 15.1426 24.6308C15.1426 24.4384 15.1717 24.3064 15.3618 24.1991C16.167 23.7495 16.9633 23.2798 17.7618 22.8212C17.8199 22.7877 17.8826 22.7631 17.9877 22.7116V24.3064C17.9877 25.1698 18.0011 26.0354 17.9832 26.8988C17.972 27.3909 18.1622 27.7241 18.5916 27.9657C19.8285 28.6636 21.0498 29.3883 22.2867 30.0839C22.5305 30.2203 22.6043 30.3724 22.5998 30.6408C22.5842 31.5847 22.5931 32.5308 22.5931 33.5508L22.5953 33.553ZM20.0746 14.91C19.6116 14.6371 19.2157 14.6393 18.7527 14.91C16.1581 16.4265 13.5523 17.9228 10.9487 19.4259C10.8391 19.4908 10.7251 19.5489 10.5305 19.6541C10.5998 18.6654 10.3873 17.7327 10.7251 16.8291C10.9085 16.3348 11.2529 15.9635 11.7092 15.6995C13.8811 14.4447 16.0507 13.1877 18.227 11.9396C19.0211 11.4833 19.8308 11.4945 20.6248 11.953C23.0964 13.3756 25.5657 14.8026 28.0306 16.2341C28.1357 16.2945 28.2677 16.4309 28.2677 16.5338C28.2856 17.5493 28.2788 18.567 28.2788 19.6563C27.3819 19.1396 26.5543 18.6609 25.7267 18.1823C23.8412 17.093 21.9512 16.0149 20.0746 14.91ZM37.4427 30.8779C37.3778 31.6764 36.9103 32.2423 36.2192 32.6404C33.5732 34.1614 30.9294 35.6913 28.2856 37.2168C27.4557 37.6954 26.6259 38.1741 25.7938 38.6527C25.6932 38.7109 25.5903 38.7601 25.4539 38.8317C25.4449 38.693 25.4337 38.5924 25.4337 38.4917C25.4337 37.6149 25.4382 36.7404 25.4293 35.8636C25.4293 35.6645 25.4762 35.5437 25.6596 35.4386C29.5157 33.2198 33.3696 30.9942 37.2212 28.7709C37.2794 28.7374 37.3443 28.7105 37.4539 28.6591C37.4539 29.4375 37.4986 30.1622 37.4427 30.8779ZM37.4628 25.3577C37.4561 26.2658 36.9663 26.9033 36.1901 27.3506C33.175 29.0841 30.1622 30.8265 27.1493 32.5666C26.5991 32.8842 26.0466 33.1996 25.4561 33.5396C25.4472 33.3897 25.436 33.2913 25.436 33.1907C25.436 32.3273 25.4449 31.4617 25.4293 30.5983C25.4248 30.3523 25.5075 30.2226 25.72 30.0995C28.46 28.5271 31.1911 26.9368 33.9355 25.3733C34.4231 25.096 34.6378 24.7538 34.6334 24.1812C34.6132 21.1974 34.6244 18.2136 34.6244 15.2298V14.7087C35.3402 15.1404 36.0112 15.496 36.624 15.9299C37.1832 16.3258 37.465 16.9253 37.4673 17.6164C37.4762 20.1976 37.4829 22.7788 37.465 25.3599L37.4628 25.3577Z" fill="%230D0D0D"></path><path fill-rule="evenodd" d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2Z" fill="url(%23paint2_radial_6324_83922)"></path><path fill-rule="evenodd" d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2Z" fill="url(%23paint3_radial_6324_83922)"></path><defs><radialGradient id="paint0_radial_6324_83922" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(13.4442 13.3899) rotate(44.9817) scale(46.7487 99.1435)"><stop stop-color="%23A3EEF8"></stop><stop offset="0.177083" stop-color="%23A4DCF5"></stop><stop offset="0.380208" stop-color="%23A6AEEC"></stop><stop offset="1" stop-color="%23ECBEE1"></stop></radialGradient><radialGradient id="paint1_radial_6324_83922" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(25.9515 43.7068) rotate(84.265) scale(24.2138 46.3215)"><stop stop-color="%23FCF5EE"></stop><stop offset="0.715135" stop-color="%23ECBEE1" stop-opacity="0"></stop></radialGradient><radialGradient id="paint2_radial_6324_83922" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(12.7405 12.6825) rotate(44.9817) scale(49.8653 105.753)"><stop stop-color="%23A3EEF8"></stop><stop offset="0.177083" stop-color="%23A4DCF5"></stop><stop offset="0.380208" stop-color="%23A6AEEC"></stop><stop offset="1" stop-color="%23ECBEE1"></stop></radialGradient><radialGradient id="paint3_radial_6324_83922" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(26.0816 45.0206) rotate(84.265) scale(25.828 49.4096)"><stop stop-color="%23FCF5EE"></stop><stop offset="0.715135" stop-color="%23ECBEE1" stop-opacity="0"></stop></radialGradient></defs></g></svg>',
  name: "Immutable Passport",
  rdns: "com.immutable.passport",
  uuid: "b90118be-7234-4c89-b89b-d5d267663eb5"
};
var gn = (r) => ({
  info: We,
  provider: r
});
var fn = (r) => ({
  info: De,
  provider: r
});

// src/provider/provider.ts
async function Rn() {
  const r = await L(
    async () => await En(),
    { type: "METAMASK_PROVIDER_ERROR" }
  );
  if (!r || !r.request) {
    throw new m(
      "No MetaMask provider installed.",
      "METAMASK_PROVIDER_ERROR"
    );
  }
  return new D(r);
}
async function sr(r, e) {
  let t = null;
  let o;
  switch (r) {
    case "passport": {
      o = F.getInstance().findProvider({ rdns: We.rdns });
      if (!o) {
        if (e) {
          t = new D(
            await e.connectEvm({ announceProvider: false })
          );
        } else {
          console.error(
            "WalletProviderName was PASSPORT but the passport instance was not provided to the Checkout constructor"
          );
          throw new m(
            "Passport not provided",
            "DEFAULT_PROVIDER_ERROR"
          );
        }
      }
      break;
    }
    case "metamask": {
      o = F.getInstance().findProvider({ rdns: De.rdns });
      if (!o) {
        t = await Rn();
      }
      break;
    }
    default:
      o = F.getInstance().findProvider({ rdns: r });
      if (!o) {
        console.error(
          "The WalletProviderName that was provided is not supported"
        );
        throw new m(
          "Provider not supported",
          "DEFAULT_PROVIDER_ERROR"
        );
      }
  }
  if (!t && o) {
    t = new D(o.provider);
  }
  if (!t) {
    console.error("Failed to create provider");
    throw new m(
      "Failed to create provider",
      "DEFAULT_PROVIDER_ERROR"
    );
  }
  return {
    provider: t,
    walletProviderName: r
  };
}

// src/provider/validateProvider.ts
function cr(r) {
  return r && "send" in r && typeof r.send === "function";
}
async function b(r, e, t) {
  return L(
    async () => {
      if ("request" in e) {
        return new D(e);
      }
      if (e.ethereumProvider?.isPassport) {
        return e;
      }
      const o = {
        ...jt,
        ...t
      };
      const n = await Ie(e);
      let a = (await e.getNetwork()).chainId;
      try {
        if (!a) {
          a = (await e.getNetwork()).chainId;
        }
      } catch (c) {
        throw new m(
          "Unable to detect the browserProvider network",
          "WEB3_PROVIDER_ERROR",
          { error: c }
        );
      }
      if (a !== BigInt(n) && !o.allowMistmatchedChainId) {
        console.error("web3ChainId", a, "underlyingChainId", n, o);
        throw new m(
          "Your wallet has changed network, please switch to a supported network",
          "WEB3_PROVIDER_ERROR"
        );
      }
      const i = await $(r, {
        type: "all"
      });
      const s = i.networks.some((c) => c.chainId === Number(n));
      if (!s && !o.allowUnsupportedProvider) {
        throw new m(
          "Your wallet is connected to an unsupported network, please switch to a supported network",
          "WEB3_PROVIDER_ERROR"
        );
      }
      return e;
    },
    {
      type: "WEB3_PROVIDER_ERROR"
    }
  );
}

// src/readOnlyProviders/readOnlyProvider.ts
import { JsonRpcProvider as Tn } from "ethers";
async function Fe(r, e) {
  if (r.isProduction && e?.has(1)) return e;
  if (e?.has(11155111)) return e;
  const t = /* @__PURE__ */ new Map();
  const o = await $(r, {
    type: "all"
  });
  o.networks.forEach((n) => {
    const a = r.networkMap.get(Number(n.chainId))?.rpcUrls[0];
    const i = new Tn(a);
    t.set(Number(n.chainId), i);
  });
  return t;
}

// src/smartCheckout/aggregators/allowanceAggregator.ts
var dr = (r, e, t) => {
  const o = [];
  if (!r.sufficient) {
    for (const n of r.allowances) {
      if (!n.sufficient) o.push(n);
    }
  }
  if (!e.sufficient) {
    for (const n of e.allowances) {
      if (!n.sufficient) o.push(n);
    }
  }
  if (!t.sufficient) {
    for (const n of t.allowances) {
      if (!n.sufficient) o.push(n);
    }
  }
  return o;
};

// src/smartCheckout/aggregators/itemAggregator.ts
var In = (r) => {
  const e = /* @__PURE__ */ new Map();
  const t = [];
  r.forEach((o) => {
    const { type: n } = o;
    if (n !== "NATIVE" || o.isFee) {
      t.push(o);
      return;
    }
    const a = {
      ...o,
      isFee: "isFee" in o ? o.isFee : false
    };
    const { amount: i } = a;
    const s = e.get(n);
    if (s && s.type === "NATIVE") {
      s.amount += i;
    } else {
      e.set(n, { ...a });
    }
  });
  return t.concat(Array.from(e.values()));
};
var hn = (r) => {
  const e = /* @__PURE__ */ new Map();
  const t = [];
  r.forEach((o) => {
    const { type: n } = o;
    if (n !== "ERC20" || o.isFee) {
      t.push(o);
      return;
    }
    const a = {
      ...o,
      isFee: "isFee" in o ? o.isFee : false
    };
    const { tokenAddress: i, spenderAddress: s, amount: c } = a;
    const p = `${i}${s}`;
    const u = e.get(p);
    if (u && u.type === "ERC20") {
      u.amount += c;
    } else {
      e.set(p, { ...a });
    }
  });
  return t.concat(Array.from(e.values()));
};
var yn = (r) => {
  const e = /* @__PURE__ */ new Map();
  const t = [];
  r.forEach((o) => {
    const { type: n } = o;
    if (n !== "ERC721") {
      t.push(o);
      return;
    }
    const { contractAddress: a, spenderAddress: i, id: s } = o;
    const c = `${a}${i}${s}`;
    const p = e.get(c);
    if (!p) e.set(c, { ...o });
  });
  return t.concat(Array.from(e.values()));
};
var An = (r) => {
  const e = /* @__PURE__ */ new Map();
  const t = [];
  r.forEach((o) => {
    const { type: n } = o;
    if (n !== "ERC1155") {
      t.push(o);
      return;
    }
    const {
      contractAddress: a,
      spenderAddress: i,
      id: s,
      amount: c
    } = o;
    const p = `${a}${i}${s}`;
    const u = e.get(p);
    if (u && u.type === "ERC1155") {
      u.amount += c;
    } else {
      e.set(p, { ...o });
    }
  });
  return t.concat(Array.from(e.values()));
};
var ht = (r) => An(yn(hn(In(r))));

// src/smartCheckout/allowance/erc20.ts
import { Contract as lr } from "ethers";
var wn = async (r, e, t, o) => {
  try {
    const n = new lr(
      t,
      JSON.stringify(W),
      r
    );
    return await n.allowance(e, o);
  } catch (n) {
    throw new m(
      "Failed to get the allowance for ERC20",
      "GET_ERC20_ALLOWANCE_ERROR",
      { contractAddress: t, error: n }
    );
  }
};
var Pn = async (r, e, t, o, n) => {
  try {
    const a = new lr(
      t,
      JSON.stringify(W),
      r
    );
    const i = await a.approve.populateTransaction(o, n);
    if (i) i.from = e;
    return i;
  } catch (a) {
    throw new m(
      "Failed to get the approval transaction for ERC20",
      "GET_ERC20_ALLOWANCE_ERROR",
      { contractAddress: t, error: a }
    );
  }
};
var pr = async (r, e, t) => {
  let o = true;
  const n = [];
  const a = /* @__PURE__ */ new Map();
  const i = /* @__PURE__ */ new Map();
  const s = /* @__PURE__ */ new Map();
  const c = /* @__PURE__ */ new Map();
  for (const R of t) {
    if (R.type !== "ERC20") continue;
    const { tokenAddress: C, spenderAddress: E } = R;
    const T = `${C}${E}`;
    a.set(T, R);
    i.set(
      T,
      wn(r, e, C, E)
    );
  }
  const p = await Promise.all(i.values());
  const u = Array.from(i.keys());
  for (let R = 0; R < p.length; R++) {
    const C = a.get(u[R]);
    if (!C || C.type !== "ERC20") continue;
    if (p[R] >= C.amount) {
      n.push({
        sufficient: true,
        itemRequirement: C
      });
      continue;
    }
    o = false;
    const { tokenAddress: E, spenderAddress: T } = C;
    const y = `${E}${T}`;
    const I = C.amount - p[R];
    s.set(
      y,
      {
        type: "ERC20",
        sufficient: false,
        delta: I,
        itemRequirement: C,
        approvalTransaction: void 0
      }
    );
    c.set(
      y,
      Pn(
        r,
        e,
        E,
        T,
        I
      )
    );
  }
  const g = await Promise.all(c.values());
  const f = Array.from(c.keys());
  g.forEach((R, C) => {
    const E = s.get(f[C]);
    if (!E) return;
    if (E.sufficient) return;
    E.approvalTransaction = R;
  });
  return { sufficient: o, allowances: n.concat(Array.from(s.values())) };
};

// src/smartCheckout/allowance/erc721.ts
import { Contract as yt } from "ethers";
var Sn = async (r, e, t, o) => {
  try {
    const n = new yt(
      t,
      JSON.stringify(ne),
      r
    );
    return await n.isApprovedForAll(e, o);
  } catch (n) {
    throw new m(
      "Failed to check approval for all ERC721s of collection",
      "GET_ERC721_ALLOWANCE_ERROR",
      {
        ownerAddress: e,
        contractAddress: t,
        spenderAddress: o,
        error: n
      }
    );
  }
};
var kn = async (r, e, t, o, n) => {
  try {
    const a = new yt(
      t,
      JSON.stringify(ne),
      r
    );
    const i = await a.approve.populateTransaction(o, n);
    if (i) i.from = e;
    return i;
  } catch (a) {
    throw new m(
      "Failed to get the approval transaction for ERC721",
      "GET_ERC721_ALLOWANCE_ERROR",
      {
        id: n.toString(),
        contractAddress: t,
        spenderAddress: o,
        ownerAddress: e,
        error: a
      }
    );
  }
};
var vn = async (r, e, t) => {
  try {
    const o = new yt(
      e,
      JSON.stringify(ne),
      r
    );
    return await o.getApproved(t);
  } catch (o) {
    throw new m(
      "Failed to get approved address for ERC721",
      "GET_ERC721_ALLOWANCE_ERROR",
      {
        id: t.toString(),
        contractAddress: e,
        error: o
      }
    );
  }
};
var ur = (r, e) => {
  try {
    if (!r.trim()) {
      throw new m(
        "Invalid ERC721 ID",
        "GET_ERC721_ALLOWANCE_ERROR",
        { id: r, contractAddress: e }
      );
    }
    return BigInt(r);
  } catch (t) {
    throw new m(
      "Invalid ERC721 ID",
      "GET_ERC721_ALLOWANCE_ERROR",
      { id: r, contractAddress: e }
    );
  }
};
var Nn = async (r, e, t) => {
  const o = /* @__PURE__ */ new Map();
  const n = /* @__PURE__ */ new Map();
  for (const s of e) {
    if (s.type !== "ERC721") continue;
    const { contractAddress: c, spenderAddress: p } = s;
    const u = `${c}-${p}`;
    o.set(u, false);
    if (n.has(u)) continue;
    n.set(u, Sn(
      r,
      t,
      c,
      p
    ));
  }
  const a = await Promise.all(n.values());
  const i = Array.from(n.keys());
  a.forEach((s, c) => {
    o.set(i[c], s);
  });
  return o;
};
var mr = async (r, e, t) => {
  let o = true;
  const n = [];
  const a = /* @__PURE__ */ new Map();
  const i = /* @__PURE__ */ new Map();
  const s = /* @__PURE__ */ new Map();
  const c = /* @__PURE__ */ new Map();
  const p = await Nn(
    r,
    t,
    e
  );
  for (const C of t) {
    if (C.type !== "ERC721") continue;
    const { contractAddress: E, id: T, spenderAddress: y } = C;
    const I = `${E}-${y}`;
    const P = p.get(I);
    if (P) {
      n.push({
        sufficient: true,
        itemRequirement: C
      });
      continue;
    }
    const v = `${E}-${T}`;
    const O = ur(T, E);
    a.set(v, C);
    i.set(
      v,
      vn(r, E, O)
    );
  }
  const u = await Promise.all(i.values());
  const g = Array.from(i.keys());
  for (let C = 0; C < u.length; C++) {
    const E = a.get(g[C]);
    if (!E || E.type !== "ERC721") continue;
    if (u[C] === E.spenderAddress) {
      n.push({
        sufficient: true,
        itemRequirement: E
      });
      continue;
    }
    o = false;
    const { contractAddress: T, id: y, spenderAddress: I } = E;
    const P = `${T}-${y}`;
    const v = ur(y, T);
    s.set(
      P,
      {
        type: "ERC721",
        sufficient: false,
        itemRequirement: E,
        approvalTransaction: void 0
      }
    );
    c.set(
      P,
      kn(
        r,
        e,
        T,
        I,
        v
      )
    );
  }
  const f = await Promise.all(c.values());
  const R = Array.from(c.keys());
  f.forEach((C, E) => {
    const T = s.get(R[E]);
    if (!T) return;
    if (T.sufficient) return;
    T.approvalTransaction = C;
  });
  return { sufficient: o, allowances: n.concat(Array.from(s.values())) };
};

// src/smartCheckout/allowance/erc1155.ts
import { Contract as gr } from "ethers";
var _n = async (r, e, t, o) => {
  try {
    const n = new gr(
      t,
      JSON.stringify(at),
      r
    );
    return await n.isApprovedForAll(e, o);
  } catch (n) {
    throw new m(
      "Failed to check approval for all ERC1155s of collection",
      "GET_ERC1155_ALLOWANCE_ERROR",
      {
        ownerAddress: e,
        contractAddress: t,
        spenderAddress: o,
        error: n
      }
    );
  }
};
var On = async (r, e, t, o) => {
  try {
    const n = new gr(
      t,
      JSON.stringify(at),
      r
    );
    const a = await n.setApprovalForAll.populateTransaction(o, true);
    if (a) a.from = e;
    return a;
  } catch (n) {
    throw new m(
      "Failed to get the approval transaction for ERC1155",
      "GET_ERC1155_ALLOWANCE_ERROR",
      {
        contractAddress: t,
        spenderAddress: o,
        ownerAddress: e,
        error: n
      }
    );
  }
};
var fr = async (r, e, t) => {
  const o = t.filter(
    (a) => a.type === "ERC1155"
  );
  const n = await Promise.all(
    o.map(async (a) => {
      const i = await _n(
        r,
        e,
        a.contractAddress,
        a.spenderAddress
      );
      if (i) {
        return {
          sufficient: true,
          itemRequirement: a
        };
      }
      const s = await On(
        r,
        e,
        a.contractAddress,
        a.spenderAddress
      );
      return {
        type: "ERC1155",
        sufficient: false,
        itemRequirement: a,
        approvalTransaction: s
      };
    })
  );
  return {
    sufficient: n.some((a) => a.sufficient),
    allowances: n
  };
};

// src/smartCheckout/balanceCheck/balanceCheck.ts
import { Contract as Ln, formatUnits as Dn } from "ethers";

// src/smartCheckout/aggregators/balanceAggregator.ts
var xn = (r) => {
  const e = /* @__PURE__ */ new Map();
  const t = [];
  r.forEach((o) => {
    const { type: n } = o;
    if (n !== "NATIVE" || o.isFee) {
      t.push(o);
      return;
    }
    const { amount: a } = o;
    const i = e.get(n);
    if (i && i.type === "NATIVE") {
      i.amount += a;
    } else {
      e.set(n, { ...o });
    }
  });
  return t.concat(Array.from(e.values()));
};
var Bn = (r) => {
  const e = /* @__PURE__ */ new Map();
  const t = [];
  r.forEach((o) => {
    const { type: n } = o;
    if (n !== "ERC20" || o.isFee) {
      t.push(o);
      return;
    }
    const { tokenAddress: a, amount: i } = o;
    const s = `${a}`;
    const c = e.get(s);
    if (c && c.type === "ERC20") {
      c.amount += i;
    } else {
      e.set(s, { ...o });
    }
  });
  return t.concat(Array.from(e.values()));
};
var Mn = (r) => {
  const e = /* @__PURE__ */ new Map();
  const t = [];
  r.forEach((o) => {
    const { type: n } = o;
    if (n !== "ERC721") {
      t.push(o);
      return;
    }
    const { contractAddress: a, id: i } = o;
    const s = `${a}${i}`;
    const c = e.get(s);
    if (!c) e.set(s, { ...o });
  });
  return t.concat(Array.from(e.values()));
};
var Er = (r) => Mn(Bn(xn(r)));

// src/smartCheckout/balanceCheck/balanceRequirement.ts
import { Contract as bn, formatUnits as Ue } from "ethers";
var Rr = (r) => r.map((e) => {
  switch (e.type) {
    case "ERC20":
      return {
        address: e.tokenAddress
      };
    case "NATIVE":
      return {
        address: x
      };
    case "ERC721":
    default:
      return {
        address: e.contractAddress
      };
  }
});
var Cr = (r, e) => {
  const t = BigInt(1);
  const o = e.find((s) => {
    const c = s;
    return h(
      c.contractAddress,
      r.contractAddress
    ) && c.id === r.id;
  });
  const n = t < 0 || t === 0n || o && o.balance >= t;
  const a = t - (o?.balance ?? BigInt(0));
  let i = o;
  if (!i) {
    i = {
      type: "ERC721",
      balance: BigInt(0),
      formattedBalance: "0",
      contractAddress: r.contractAddress,
      id: r.id
    };
  }
  return {
    sufficient: n ?? false,
    type: "ERC721",
    delta: {
      balance: a,
      formattedBalance: a.toString()
    },
    current: i,
    required: {
      ...i,
      balance: BigInt(1),
      formattedBalance: "1"
    },
    isFee: false
  };
};
var Tr = (r, e) => {
  if (r.type === "ERC20") {
    return e.find((t) => {
      return h(
        t.token?.address,
        r.tokenAddress
      );
    });
  }
  return e.find((t) => {
    return B(t.token?.address);
  });
};
var Ir = async (r, e, t) => {
  const o = {};
  for (const n of r) {
    if (n.type === "NATIVE") {
      o[x] = ke;
      continue;
    }
    const a = Tr(n, e);
    let i = a?.token.address ?? "";
    let s = a?.token.name ?? "";
    let c = a?.token.symbol ?? "";
    let p = a?.token.decimals ?? j;
    if (!a && n.type === "ERC20") {
      i = n.tokenAddress;
      if (i.toLowerCase() in o) {
        continue;
      }
      try {
        const u = new bn(
          n.tokenAddress,
          JSON.stringify(W),
          t
        );
        const [g, f, R] = await Promise.all([
          u.name(),
          u.symbol(),
          u.decimals()
        ]);
        i = n.tokenAddress;
        p = R;
        s = g;
        c = f;
      } catch (u) {
        console.error(
          "Failed to query contract information",
          n.tokenAddress
        );
      }
    }
    o[i.toLowerCase()] = {
      address: i,
      name: s,
      symbol: c,
      decimals: p
    };
  }
  return o;
};
var hr = (r, e, t) => {
  let o = Tr(r, e);
  const n = r.amount;
  const a = n < 0 || n === 0n || o && o?.balance >= n;
  const i = n - (o?.balance ?? BigInt(0));
  if (r.type === "NATIVE") {
    if (!o) {
      o = {
        type: "NATIVE",
        balance: BigInt(0),
        formattedBalance: "0",
        token: t
      };
    }
    return {
      sufficient: a ?? false,
      type: "NATIVE",
      delta: {
        balance: i,
        formattedBalance: Ue(i, t.decimals)
      },
      current: {
        ...o,
        type: "NATIVE",
        token: t
      },
      required: {
        ...o,
        type: "NATIVE",
        balance: BigInt(r.amount),
        formattedBalance: Ue(r.amount, t.decimals),
        token: t
      },
      isFee: r.isFee
    };
  }
  if (!o) {
    o = {
      type: r.type,
      balance: BigInt(0),
      formattedBalance: "0",
      token: t
    };
  }
  return {
    sufficient: a ?? false,
    type: "ERC20",
    delta: {
      balance: i,
      formattedBalance: Ue(i, t.decimals)
    },
    current: {
      ...o,
      token: t
    },
    required: {
      ...o,
      token: t,
      balance: BigInt(r.amount),
      formattedBalance: Ue(r.amount, t.decimals)
    },
    isFee: r.isFee
  };
};

// src/smartCheckout/balanceCheck/balanceCheck.ts
var Wn = async (r, e, t, o, n = false) => {
  try {
    const a = /* @__PURE__ */ new Map();
    Rr(o).forEach(
      (s) => {
        if (!s.address) return;
        a.set(s.address.toLocaleLowerCase(), s);
      }
    );
    const { balances: i } = await V(r, e, t, w(r), n);
    return i.filter(
      (s) => a.get((s.token.address || x).toLocaleLowerCase())
    );
  } catch (a) {
    throw new m(
      "Failed to get balances",
      "GET_BALANCE_ERROR",
      { error: a }
    );
  }
};
var Fn = async (r, e, t) => {
  const o = [];
  const n = /* @__PURE__ */ new Map();
  const a = /* @__PURE__ */ new Map();
  t.forEach((i) => {
    if (i.type !== "ERC721") return;
    const s = new Ln(
      i.contractAddress,
      JSON.stringify(ne),
      r
    );
    n.set(i.contractAddress, i);
    a.set(i.contractAddress, s.ownerOf(i.id));
  });
  try {
    const i = await Promise.all(a.values());
    const s = Array.from(a.keys());
    i.forEach((c, p) => {
      const u = n.get(s[p]);
      let g = 0;
      if (u && h(e, c)) {
        g = 1;
      }
      o.push({
        type: "ERC721",
        balance: BigInt(g),
        formattedBalance: g.toString(),
        contractAddress: u.contractAddress,
        id: u.id
      });
    });
  } catch (i) {
    throw new m(
      "Failed to get ERC721 balances",
      "GET_ERC721_BALANCE_ERROR",
      { error: i }
    );
  }
  return o;
};
var yr = async (r, e, t, o, n = false) => {
  const a = Er(o);
  const i = [];
  const s = [];
  a.forEach((f) => {
    switch (f.type) {
      case "ERC20":
      case "NATIVE":
        i.push(f);
        break;
      case "ERC721":
        s.push(f);
        break;
      default:
    }
  });
  i.sort((f) => "isFee" in f && f.isFee ? 1 : -1);
  if (s.length === 0 && i.length === 0) {
    throw new m(
      "Unsupported item requirement balance check",
      "UNSUPPORTED_BALANCE_REQUIREMENT_ERROR"
    );
  }
  const c = [];
  if (i.length > 0) {
    c.push(Wn(r, e, t, a, n));
  }
  if (s.length > 0) {
    c.push(Fn(e, t, a));
  }
  const p = await Promise.all(c);
  const u = [];
  if (i.length > 0) {
    const f = p.shift() ?? [];
    const R = new Map(f.map((E) => {
      const T = E.type === "NATIVE" ? x : E.token.address?.toLowerCase();
      return [T, E];
    }));
    const C = await Ir(i, f, e);
    i.forEach((E) => {
      const T = (E.tokenAddress ?? x).toLowerCase();
      const y = C[T];
      const I = R.get(T);
      const P = hr(E, [...R.values()], y);
      u.push(P);
      if (!I) {
        return;
      }
      const v = I.balance - P.required.balance;
      R.set(T, {
        ...I,
        balance: v,
        formattedBalance: Dn(v, P.required.token.decimals)
      });
    });
  }
  if (s.length > 0) {
    const f = p.shift() ?? [];
    s.forEach((R) => {
      u.push(Cr(R, f));
    });
  }
  const g = u.find((f) => !f.sufficient) === void 0;
  return {
    sufficient: g,
    balanceRequirements: u
  };
};

// src/smartCheckout/gas/gasCalculator.ts
var Ar = async (r, e) => {
  try {
    return await r.estimateGas(e);
  } catch (t) {
    throw new m(
      "Failed to estimate gas for transaction",
      "UNPREDICTABLE_GAS_LIMIT",
      { error: t }
    );
  }
};
var Un = (r, e) => {
  if (e.type === "TRANSACTION" || e.gasToken.type === "NATIVE") {
    return {
      type: "NATIVE",
      amount: r,
      isFee: true
    };
  }
  return {
    type: "ERC20",
    amount: r,
    tokenAddress: e.gasToken.tokenAddress,
    spenderAddress: "",
    isFee: true
  };
};
var wr = async (r, e, t) => {
  const o = [];
  let n = BigInt(0);
  for (const i of e) {
    if (i.approvalTransaction === void 0) continue;
    o.push(Ar(r, i.approvalTransaction));
  }
  if (t.type === "TRANSACTION") {
    o.push(Ar(r, t.transaction));
  } else {
    const i = await r.getFeeData();
    const s = Ct(i);
    if (s !== null) {
      const c = s * t.gasToken.limit;
      if (c) n += c;
    }
  }
  const a = await Promise.all(o);
  a.forEach((i) => {
    n += i;
  });
  if (n === 0n) return null;
  return Un(n, t);
};

// src/smartCheckout/routing/geoBlocking.ts
var Pr = async () => true;
var Sr = async (r) => {
  const e = Ne(r.isDevelopment, r.isProduction);
  try {
    return await e.checkDexAvailability();
  } catch {
    return false;
  }
};

// src/smartCheckout/routing/routingOptions.ts
function At(r) {
  return r?.ethereumProvider?.isPassport === true;
}
var kr = async (r, e) => {
  const t = {
    onRamp: r.isOnRampEnabled,
    swap: r.isSwapEnabled,
    bridge: r.isBridgeEnabled
  };
  const o = [];
  if (t.onRamp) {
    o.push({ id: "onRamp", promise: Pr() });
  }
  if (t.swap) {
    o.push({ id: "swap", promise: Sr(r) });
  }
  if (o.length > 0) {
    const n = o.map((i) => i.promise);
    const a = await Promise.allSettled(n);
    a.forEach((i, s) => {
      const c = o[s].id;
      t[c] = t[c] && i.status === "fulfilled" && i.value;
    });
  }
  t.bridge = t.bridge && !At(e);
  return t;
};

// src/smartCheckout/routing/tokenBalances.ts
var vr = async (r, e, t, o) => {
  const n = /* @__PURE__ */ new Map();
  const a = /* @__PURE__ */ new Map();
  if (e.size === 0) {
    const s = {
      success: false,
      error: new m("No L1 or L2 provider available", "PROVIDER_ERROR"),
      balances: []
    };
    n.set(_(r), s);
    n.set(w(r), s);
    return n;
  }
  if (o.bridge) {
    const s = _(r);
    if (e.has(s)) {
      a.set(s, V(
        r,
        e.get(s),
        t,
        s
      ));
    } else {
      n.set(_(r), {
        success: false,
        error: new m(`No L1 provider available for ${s}`, "PROVIDER_ERROR"),
        balances: []
      });
    }
  }
  const i = w(r);
  if (e.has(i)) {
    a.set(i, V(
      r,
      e.get(i),
      t,
      i
    ));
  } else {
    n.set(w(r), {
      success: false,
      error: new m(`No L2 provider available for ${i}`, "PROVIDER_ERROR"),
      balances: []
    });
  }
  if (a.size > 0) {
    const s = Array.from(a.keys());
    const c = await Promise.allSettled(a.values());
    c.forEach((p, u) => {
      const g = s[u];
      if (p.status === "fulfilled") {
        n.set(g, {
          success: true,
          balances: p.value.balances
        });
      } else {
        n.set(g, {
          success: false,
          error: new m(`Error getting ${i} balances`, "GET_BALANCE_ERROR"),
          balances: []
        });
      }
    });
  }
  return n;
};

// src/smartCheckout/routing/swap/swapRoute.ts
import { formatUnits as qe } from "ethers";

// src/smartCheckout/routing/swap/quoteFetcher.ts
var Ge = async (r, e, t, o, n) => {
  const a = /* @__PURE__ */ new Map();
  const i = 1;
  try {
    const s = await se(e, r);
    const c = [];
    const p = [];
    for (const g of n) {
      if (g === o.address) continue;
      c.push(s.getUnsignedSwapTxFromAmountOut(
        t,
        g,
        o.address,
        o.amount,
        i
      ));
      p.push(g);
    }
    const u = await k(
      r,
      "Time to resolve swap quotes from the dex",
      Promise.allSettled(c)
    );
    u.forEach((g, f) => {
      if (g.status === "rejected") return;
      const R = p[f];
      a.set(R, {
        quote: g.value.quote,
        approval: g.value.approval?.gasFeeEstimate ?? null,
        swap: g.value.swap.gasFeeEstimate
      });
    });
    return a;
  } catch {
    return a;
  }
};

// src/smartCheckout/routing/swap/swapRoute.ts
var Gn = (r, e, t) => {
  let o = BigInt(0);
  let n = "0";
  let a;
  if (r) {
    o = r.value;
    n = qe(r.value, r.token.decimals);
    a = {
      name: r.token.name ?? "",
      symbol: r.token.symbol ?? "",
      address: r.token.address,
      decimals: r.token.decimals
    };
  }
  let i = BigInt(0);
  let s = "0";
  let c;
  if (e) {
    i = e.value;
    s = qe(e.value, e.token.decimals);
    c = {
      name: e.token.name ?? "",
      symbol: e.token.symbol ?? "",
      address: e.token.address,
      decimals: e.token.decimals
    };
  }
  const p = [];
  for (const u of t) {
    p.push({
      type: "SWAP_FEE",
      amount: u.amount.value,
      formattedAmount: qe(u.amount.value, u.amount.token.decimals),
      basisPoints: u.basisPoints,
      token: {
        name: u.amount.token.name ?? "",
        symbol: u.amount.token.symbol ?? "",
        address: u.amount.token.address,
        decimals: u.amount.token.decimals
      }
    });
  }
  return {
    approvalGasFee: {
      type: "GAS",
      amount: o,
      formattedAmount: n,
      token: a
    },
    swapGasFee: {
      type: "GAS",
      amount: i,
      formattedAmount: s,
      token: c
    },
    swapFees: p
  };
};
var qn = (r, e, t, o) => {
  const n = t.token.address;
  let a = "ERC20";
  if (B(n)) {
    a = "NATIVE";
  }
  return {
    type: "SWAP",
    chainId: r,
    fundingItem: {
      type: a,
      fundsRequired: {
        amount: e,
        formattedAmount: Z(qe(
          e,
          t.token.decimals
        ))
      },
      userBalance: {
        balance: t.balance,
        formattedBalance: t.formattedBalance
      },
      token: t.token
    },
    fees: o
  };
};
var jn = (r) => {
  if (r.type === "ERC20") {
    return !!r.required.token.address;
  }
  if (r.type === "NATIVE") {
    return B(r.required.token.address);
  }
  return false;
};
var Vn = (r) => {
  let e = "";
  let t = BigInt(0);
  switch (r.type) {
    case "ERC20":
      e = r.required.token.address;
      t = r.delta.balance;
      break;
    case "NATIVE":
      t = r.delta.balance;
      break;
    default:
      break;
  }
  return { address: e, amount: t };
};
var Kn = (r, e) => {
  if (!e) return { sufficient: true, approvalGasFee: BigInt(0), approvalGasTokenAddress: "" };
  const t = e.value;
  const o = e.token.address;
  if (r.length === 0) {
    return {
      sufficient: false,
      approvalGasFee: t,
      approvalGasTokenAddress: o
    };
  }
  const n = r.find(
    (a) => B(a.token.address) && B(o) || h(a.token.address, o)
  );
  if (!n) return { sufficient: false, approvalGasFee: t, approvalGasTokenAddress: o };
  if (n.balance < t) {
    return {
      sufficient: false,
      approvalGasFee: t,
      approvalGasTokenAddress: o
    };
  }
  return { sufficient: true, approvalGasFee: t, approvalGasTokenAddress: o };
};
var Hn = (r, e, t, o, n) => {
  const a = /* @__PURE__ */ new Map();
  if (e.approvalGasFee > BigInt(0)) {
    a.set(e.approvalGasTokenAddress, e.approvalGasFee);
  }
  if (t) {
    const i = a.get(t.token.address);
    if (i) {
      a.set(t.token.address, i + t.value);
    } else {
      a.set(t.token.address, t.value);
    }
  }
  if (n) {
    const i = a.get(n.address);
    if (i) {
      a.set(n.address, i + n.amount);
    } else {
      a.set(n.address, n.amount);
    }
  }
  for (const i of o) {
    const s = a.get(i.amount.token.address);
    if (s) {
      a.set(i.amount.token.address, s + i.amount.value);
      continue;
    }
    a.set(i.amount.token.address, i.amount.value);
  }
  for (const [i, s] of a.entries()) {
    if (s === BigInt(0)) continue;
    const c = r.find(
      (p) => B(p.token.address) && B(i) || h(p.token.address, i)
    );
    if (!c) {
      return false;
    }
    if (c.balance < s) {
      return false;
    }
  }
  return true;
};
var zn = (r, e, t, o, n, a) => {
  let i = BigInt(0);
  let s = "";
  let c = false;
  e.balanceRequirements.forEach((p) => {
    if (p.type === "NATIVE" || p.type === "ERC20") {
      if (p.required.token.address && h(p.required.token.address, t)) {
        s = p.required.token.address;
        c = true;
        i = r - p.required.balance;
      }
    }
  });
  if (!c) return true;
  if (h(n.approvalGasTokenAddress, s)) {
    i -= n.approvalGasFee;
  }
  for (const p of a) {
    if (h(p.amount.token.address, s)) {
      i -= p.amount.value;
    }
  }
  return i >= o;
};
var je = async (r, e, t, o, n, a, i) => {
  const s = [];
  if (!e.swap) return s;
  if (a.length === 0) return s;
  if (!jn(o)) return s;
  const c = Vn(o);
  const p = w(r);
  const u = n.get(p);
  if (!u) return s;
  const g = u.balances;
  if (g.length === 0) return s;
  const f = await Ge(
    r,
    w(r),
    t,
    c,
    a
  );
  const R = Array.from(f.keys());
  for (const C of R) {
    const E = f.get(C);
    if (!E) continue;
    const T = g.find(
      (v) => h(v.token.address, C)
    );
    if (!T) continue;
    const y = E.quote.amountWithMaxSlippage;
    if (T.balance < y.value) continue;
    const I = Kn(g, E.approval);
    if (!I.sufficient) continue;
    if (!Hn(
      g,
      I,
      E.swap,
      E.quote.fees,
      {
        amount: y.value,
        address: C
      }
    )) continue;
    if (!zn(
      T.balance,
      i,
      C,
      y.value,
      I,
      E.quote.fees
    )) continue;
    const P = Gn(E.approval, E.swap, E.quote.fees);
    s.push(
      qn(
        p,
        y.value,
        T,
        P
      )
    );
  }
  return s;
};

// src/smartCheckout/allowList/allowListCheck.ts
var Nr = (r, e) => {
  if (e && e.success) {
    return r.filter((t) => {
      if ("address" in t) {
        return e.balances.find(
          (o) => h(o.token.address, t.address) && o.balance > 0
        );
      }
      return e.balances.find((o) => !("address" in o.token) && o.balance > 0);
    });
  }
  return [];
};
var wt = async (r, e) => {
  if (e.onRamp) {
    const t = await z(r, { type: "onramp" });
    return t.tokens;
  }
  return [];
};
var Pt = async (r, e, t) => {
  if (t.bridge) {
    const o = _(r);
    const n = (await z(r, { type: "bridge", chainId: o })).tokens;
    const a = e.get(o);
    return Nr(n, a);
  }
  return [];
};
var Qn = async (r, e, t) => {
  if (t.swap) {
    const o = (await z(r, { type: "swap" })).tokens;
    const n = e.get(w(r));
    return Nr(o, n);
  }
  return [];
};
var _r = async (r, e, t) => {
  const o = {};
  o.swap = await Qn(r, e, t);
  o.bridge = await Pt(r, e, t);
  o.onRamp = await wt(r, t);
  return o;
};

// src/smartCheckout/routing/bridgeAndSwap/bridgeAndSwapRoute.ts
import { formatUnits as oa } from "ethers";

// src/smartCheckout/routing/bridge/bridgeRoute.ts
import { formatUnits as Ke } from "ethers";

// src/smartCheckout/routing/bridge/getEthBalance.ts
var Or = (r) => {
  for (const e of r.balances) {
    if (B(e.token.address)) {
      return e.balance;
    }
  }
  return BigInt(0);
};

// src/smartCheckout/routing/bridge/getBridgeFeeEstimate.ts
import { BridgeFeeActions as Zn } from "@imtbl/bridge-sdk";
var xr = async (r, e, t, o) => {
  const n = be(
    t,
    o,
    e,
    r
  );
  try {
    const a = await n.getFee(
      {
        action: Zn.DEPOSIT,
        gasMultiplier: "auto",
        sourceChainId: t.toString(),
        destinationChainId: o.toString()
      }
    );
    return {
      ...a,
      approvalGas: BigInt(0)
    };
  } catch (a) {
    throw new m(
      "Error estimating gas for bridge",
      "BRIDGE_GAS_ESTIMATE_ERROR",
      { error: a }
    );
  }
};

// src/smartCheckout/routing/indexer/fetchL1Representation.ts
var X = "0x0000000000000000000000000000000000000eee";
var Yn = (r) => {
  if (r === 13371) return "imtbl-zkevm-mainnet";
  if (r === 13473) return "imtbl-zkevm-testnet";
  if (r === 15003) return "imtbl-zkevm-devnet";
  return "";
};
var Jn = async (r, e) => {
  const t = await e.remote.getConfig(
    "imxAddressMapping"
  );
  return t[r] ?? "";
};
var Ve = async (r, e) => {
  if (B(e)) {
    return {
      l1address: await Jn(_(r), r),
      l2address: x
    };
  }
  const t = Yn(w(r));
  const o = Le(r);
  const n = await o.getToken({
    chainName: t,
    contractAddress: e
  });
  const a = n.result.root_contract_address;
  if (h(a ?? "", X)) {
    return {
      l1address: "native",
      l2address: e
    };
  }
  if (a === null) return void 0;
  return {
    l1address: a,
    l2address: e
  };
};

// src/smartCheckout/routing/bridge/bridgeRoute.ts
var $n = (r, e) => {
  const t = Or(r);
  return t >= e;
};
var Br = (r, e, t, o, n) => {
  const a = n?.decimals ?? j;
  const i = [];
  if (e > 0) {
    i.push({
      type: "BRIDGE_FEE",
      amount: e,
      formattedAmount: Ke(e, a),
      token: n
    });
  }
  if (t > 0) {
    i.push({
      type: "IMMUTABLE_FEE",
      amount: t,
      formattedAmount: Ke(t, a),
      token: n
    });
  }
  return {
    approvalGasFee: {
      type: "GAS",
      amount: o,
      formattedAmount: Ke(o, j),
      token: n
    },
    bridgeGasFee: {
      type: "GAS",
      amount: r,
      formattedAmount: Ke(r, j),
      token: n
    },
    bridgeFees: i
  };
};
var Mr = (r, e, t, o, n) => ({
  type: "BRIDGE",
  chainId: r,
  fundingItem: {
    type: o,
    fundsRequired: {
      amount: t.amount,
      formattedAmount: Z(t.formattedAmount)
    },
    userBalance: {
      balance: e.balance,
      formattedBalance: e.formattedBalance
    },
    token: {
      name: e.token.name,
      symbol: e.token.symbol,
      address: e.token.address,
      decimals: e.token.decimals
    }
  },
  fees: n
});
var He = async (r, e, t, o, n) => {
  if (!t.bridge) return void 0;
  const a = _(r);
  const i = w(r);
  const s = r.networkMap.get(a)?.nativeCurrency;
  const c = n.get(a);
  const p = e.get(a);
  if (!p) {
    throw new m(
      "No L1 provider available",
      "PROVIDER_ERROR",
      { chainId: a.toString() }
    );
  }
  if (c === void 0 || c.success === false) return void 0;
  const u = await Pt(r, n, t);
  if (u.length === 0) return void 0;
  const g = await Ve(r, o.l2address);
  if (!g) return void 0;
  const { l1address: f } = g;
  if (B(f)) {
    if (!u.find((v) => B(v.address))) return void 0;
  } else if (!u.find((v) => h(v.address, f))) {
    return void 0;
  }
  const R = await xr(
    r,
    e,
    a,
    i
  );
  const {
    sourceChainGas: C,
    approvalGas: E,
    bridgeFee: T,
    imtblFee: y,
    totalFees: I
  } = R;
  if (!$n(c, I)) return void 0;
  if (B(f)) {
    const v = c.balances.find((O) => B(O.token.address));
    if (v && v.balance >= o.amount + I) {
      const O = Br(
        C,
        T,
        y,
        E,
        s
      );
      return Mr(a, v, o, "NATIVE", O);
    }
    return void 0;
  }
  const P = c.balances.find(
    (v) => h(v.token.address, f)
  );
  if (P && P.balance >= o.amount) {
    const v = Br(
      C,
      T,
      y,
      E,
      s
    );
    return Mr(a, P, o, "ERC20", v);
  }
  return void 0;
};

// src/smartCheckout/routing/bridgeAndSwap/getBalancesByChain.ts
var br = (r, e) => {
  const t = { l1balances: [], l2balances: [] };
  const o = e.get(_(r));
  const n = e.get(w(r));
  if (!o) return t;
  if (o.error !== void 0) return t;
  if (!o.success) return t;
  if (!n) return t;
  if (n.error !== void 0) return t;
  if (!n.success) return t;
  const a = o.balances;
  const i = n.balances;
  return { l1balances: a, l2balances: i };
};

// src/smartCheckout/routing/bridgeAndSwap/constructBridgeRequirements.ts
import { formatUnits as Xn } from "ethers";
var ea = (r, e) => {
  let t = BigInt(0);
  r.quote.fees.forEach((o) => {
    if (h(o.amount.token.address, e)) {
      t += o.amount.value;
    }
  });
  if (r.approval) {
    if (h(r.approval.token.address, e)) {
      t += r.approval.value;
    }
  }
  return t;
};
var ta = (r, e) => {
  for (const t of r.balanceRequirements) {
    if (t.type === "NATIVE" || t.type === "ERC20") {
      if (h(t.required.token.address, e)) {
        return t.required.balance;
      }
    }
  }
  return BigInt(0);
};
var ra = (r, e, t) => {
  const o = t?.balance ?? BigInt(0);
  if (o >= r + e) {
    return BigInt(0);
  }
  if (o <= 0) {
    return r + e;
  }
  const n = o - e;
  if (n >= 0) {
    return r - n;
  }
  return r + e - o;
};
var Lr = (r, e, t, o, n) => {
  const a = [];
  for (const [i, s] of r) {
    const c = t.find((I) => h(I.token.address, i));
    const p = o.find(
      (I) => h(I.l2address, i)
    );
    if (!p) continue;
    const { l1address: u, l2address: g } = p;
    if (!u) continue;
    const f = e.find((I) => {
      if (I.token.address === void 0 && h(u, X)) {
        return true;
      }
      return h(I.token.address, u);
    });
    if (!f) continue;
    const R = s.quote.amountWithMaxSlippage.value;
    const C = ea(s, i);
    const E = R + C;
    const T = ta(
      n,
      i
    );
    const y = ra(E, T, c);
    if (y <= 0) {
      continue;
    }
    if (y >= f.balance) {
      continue;
    }
    a.push({
      amount: y,
      formattedAmount: Z(Xn(y, f.token.decimals)),
      // L2 address is used for the bridge requirement as the bridge route uses the indexer to find L1 address
      l2address: g
    });
  }
  return a;
};

// src/smartCheckout/routing/bridgeAndSwap/fetchL1ToL2Mappings.ts
var Dr = async (r, e) => {
  const t = e.map((n) => Ve(r, n.address ?? ""));
  const o = await Promise.all(t);
  return o.filter((n) => n !== void 0);
};

// src/smartCheckout/routing/bridgeAndSwap/getDexQuotes.ts
var Wr = async (r, e, t, o, n) => {
  const a = [];
  for (const s of n) {
    if (!s.address) continue;
    a.push(s.address);
  }
  const i = await Ge(
    r,
    w(r),
    e,
    {
      address: t,
      amount: o.delta.balance
    },
    a
  );
  return i;
};

// src/smartCheckout/routing/bridgeAndSwap/bridgeAndSwapRoute.ts
var na = (r, e, t, o, n, a) => {
  if (r.length === 0) return true;
  if (e.length === 0) return true;
  if (t.length === 0) return true;
  if (o.length === 0) return true;
  if (!n.bridge) return true;
  if (!n.swap) return true;
  if (a === void 0) return true;
  if (a === "") return true;
  return false;
};
var aa = (r, e, t, o) => {
  const n = [];
  for (const a of o) {
    if (!e.includes(a.l1address)) continue;
    if (h(a.l2address, r)) continue;
    const i = t.find(
      (s) => h(s.address, a.l2address)
    );
    if (!i) continue;
    n.push(i);
  }
  return n;
};
var ia = (r, e, t, o, n) => {
  const a = /* @__PURE__ */ new Map();
  for (const [c, p] of e) {
    a.set(c, {
      success: p.success,
      balances: p.balances
    });
  }
  const i = /* @__PURE__ */ new Map();
  for (const c of t) {
    if (!c.token.address) continue;
    i.set(c.token.address, c);
  }
  for (const c of o) {
    const { amount: p, l2address: u } = c;
    if (u === "") continue;
    let g = BigInt(0);
    const f = i.get(u);
    if (f) g = f.balance;
    const R = g + p;
    const C = n.find((E) => h(E.address, u));
    i.set(u, {
      balance: R,
      formattedBalance: oa(
        R,
        C.decimals
      ),
      token: C
    });
  }
  const s = Array.from(i.values());
  a.set(
    w(r),
    {
      success: true,
      balances: s
    }
  );
  return a;
};
var sa = (r, e) => {
  const t = [];
  for (const o of e) {
    const { chainId: n, fundingItem: a } = o;
    const { userBalance: i } = o.fundingItem;
    const s = r.get(n);
    if (!s) continue;
    let c = BigInt(0);
    let p = "0";
    const u = s.balances.find(
      (g) => h(g.token.address, a.token.address)
    );
    if (u) {
      c = u.balance;
      p = u.formattedBalance;
    }
    i.balance = c;
    i.formattedBalance = p;
    t.push(o);
  }
  return t;
};
var ca = (r, e, t) => {
  const o = [];
  for (const n of r) {
    if (!n) continue;
    const a = t.find(
      (s) => {
        if (n.fundingItem.token.address === void 0) {
          return h(s.l1address, X) && s.l2address;
        }
        return h(
          s.l1address,
          n.fundingItem.token.address
        ) && s.l2address;
      }
    );
    if (!a) continue;
    const i = e.find(
      (s) => h(s.fundingItem.token.address, a.l2address)
    );
    if (!i) continue;
    o.push({
      bridgeFundingStep: n,
      swapFundingStep: i
    });
  }
  return o;
};
var Fr = async (r, e, t, o, n, a, i, s, c) => {
  const { l1balances: p, l2balances: u } = br(r, a);
  const g = o.required.token.address;
  if (na(
    i,
    s,
    p,
    u,
    t,
    g
  )) return [];
  const f = await Dr(r, s);
  const R = aa(
    g,
    i,
    s,
    f
  );
  if (R.length === 0) return [];
  const C = await Wr(
    r,
    n,
    g,
    o,
    R
  );
  const E = Lr(
    C,
    p,
    u,
    f,
    c
  );
  if (E.length === 0) return [];
  const T = /* @__PURE__ */ new Map();
  const y = /* @__PURE__ */ new Map();
  const I = [];
  for (const G of E) {
    if (!G.l2address) continue;
    T.set(
      G.l2address,
      He(
        r,
        e,
        t,
        G,
        a
      )
    );
    y.set(G.l2address, {
      amount: G.amount,
      formattedAmount: G.formattedAmount,
      l2address: G.l2address
    });
  }
  const P = await Promise.all(T.values());
  const v = Array.from(T.keys());
  const O = [];
  P.forEach((G, rt) => {
    const K = v[rt];
    if (G === void 0) return;
    O.push(K);
    const N = y.get(K);
    if (!N) return;
    I.push({
      amount: N.amount,
      formattedAmount: N.formattedAmount,
      l2address: N.l2address
    });
  });
  if (O.length === 0) return [];
  if (I.length === 0) return [];
  const Q = ia(
    r,
    a,
    u,
    I,
    s
  );
  const pe = await je(
    r,
    t,
    n,
    o,
    Q,
    O,
    c
  );
  if (!pe) return [];
  const ee = sa(
    a,
    pe
  );
  return ca(
    P,
    ee,
    f
  );
};

// src/smartCheckout/routing/onRamp/onRampRoute.ts
var Ur = async (r, e, t) => {
  if (!["ERC20", "NATIVE"].includes(t.type)) return void 0;
  const { required: o, current: n, delta: a } = t;
  let i = false;
  const s = await wt(r, e);
  s.forEach((c) => {
    if (!c.address) return;
    if (!o.token) return;
    if (B(o.token.address) || h(c.address, o.token.address)) {
      i = true;
    }
  });
  if (!i) return void 0;
  return {
    type: "ONRAMP",
    chainId: w(r),
    fundingItem: {
      type: B(o.token.address) ? "NATIVE" : "ERC20",
      fundsRequired: {
        amount: a.balance,
        formattedAmount: Z(a.formattedBalance)
      },
      userBalance: {
        balance: n.balance,
        formattedBalance: n.formattedBalance
      },
      token: o.token
    }
  };
};

// src/smartCheckout/routing/routingCalculator.ts
var da = (r) => r.bridge || r.swap || r.onRamp;
var la = (r) => {
  let e = 0;
  let t;
  for (const o of r.balanceRequirements) {
    if (!o.sufficient) {
      e++;
      t = o;
    }
  }
  if (e === 1) return t;
  return void 0;
};
var pa = async (r, e, t, o, n) => {
  let a;
  if (o === void 0) return void 0;
  if (o.type !== "NATIVE" && o.type !== "ERC20") {
    return void 0;
  }
  const i = {
    amount: o.delta.balance,
    formattedAmount: o.delta.formattedBalance,
    l2address: o.required.token.address ?? ""
  };
  if (t.bridge && o) {
    a = await He(
      r,
      e,
      t,
      i,
      n
    );
  }
  return a;
};
var ua = async (r, e, t, o, n, a, i) => {
  const s = [];
  if (!e.swap) return s;
  if (t === void 0) return s;
  if (a === void 0) return s;
  const c = n.get(w(r));
  if (!c) return s;
  if (c.error !== void 0 || !c.success) return s;
  if (a.length === 0) return s;
  const p = a.filter((u) => u.address).map((u) => u.address);
  if (p.length === 0) return s;
  return await je(
    r,
    e,
    o,
    t,
    n,
    p,
    i
  );
};
var ma = async (r, e, t, o, n, a, i, s) => {
  if (!o) return [];
  const c = a.get(_(r));
  const p = a.get(w(r));
  if (!c) return [];
  if (c.error !== void 0 || !c.success) return [];
  if (!p) return [];
  if (p.error !== void 0 || !p.success) return [];
  const u = i?.bridge ?? [];
  const g = u.map((C) => {
    if (C.address === void 0) return X;
    return C.address;
  });
  const f = i?.swap ?? [];
  if (o.type !== "NATIVE" && o.type !== "ERC20") {
    return [];
  }
  const R = await Fr(
    r,
    e,
    t,
    o,
    n,
    a,
    g,
    f,
    s
  );
  return R;
};
var ga = async (r, e, t) => {
  if (!e.onRamp) return void 0;
  if (t === void 0) return void 0;
  const o = await Ur(
    r,
    e,
    t
  );
  return o;
};
var ze = {
  swap: 1,
  bridge: 2,
  onRamp: 3,
  bridgeAndSwap: 4
};
var Qe = (r, e, t, o) => {
  if (!r) return;
  let n;
  if ("bridgeFundingStep" in r && "swapFundingStep" in r) {
    n = [r.bridgeFundingStep, r.swapFundingStep];
  } else {
    n = [r];
  }
  const a = { priority: e, steps: n };
  t.push(a);
  o?.(a);
};
var Gr = async (r, e, t, o, n) => {
  if (!da(o)) {
    return {
      type: "NO_ROUTE_OPTIONS",
      message: "No routing options are available"
    };
  }
  let a;
  try {
    a = await Fe(r);
  } catch (g) {
    throw new m(
      "Error occurred while creating read only providers",
      "PROVIDER_ERROR",
      { error: g }
    );
  }
  const i = await k(
    r,
    "Time to get token balances inside router",
    vr(
      r,
      a,
      e,
      o
    )
  );
  const s = await k(
    r,
    "Time to get routing allowlist",
    _r(r, i, o)
  );
  const c = la(t);
  const p = [];
  const u = [];
  if (o.swap) {
    p.push(
      ua(
        r,
        o,
        c,
        e,
        i,
        s.swap,
        t
      ).then((g) => {
        g.forEach((f) => {
          Qe(
            f,
            ze.swap,
            u,
            n
          );
        });
      })
    );
  }
  if (o.bridge) {
    p.push(
      pa(
        r,
        a,
        o,
        c,
        i
      ).then((g) => {
        Qe(
          g,
          ze.bridge,
          u,
          n
        );
      })
    );
  }
  if (o.onRamp) {
    p.push(
      ga(
        r,
        o,
        c
      ).then((g) => {
        Qe(
          g,
          ze.onRamp,
          u,
          n
        );
      })
    );
  }
  if (o.swap && o.bridge) {
    p.push(
      ma(
        r,
        a,
        o,
        c,
        e,
        i,
        s,
        t
      ).then((g) => {
        g.forEach((f) => {
          Qe(
            f,
            ze.bridgeAndSwap,
            u,
            n
          );
        });
      })
    );
  }
  await k(
    r,
    "Time to resolve all routes",
    Promise.all(p)
  );
  if (u.length === 0) {
    return {
      type: "NO_ROUTES_FOUND",
      message: "Smart Checkout did not find any funding routes to fulfill the transaction"
    };
  }
  return {
    type: "ROUTES_FOUND",
    fundingRoutes: u
  };
};

// src/smartCheckout/smartCheckout.ts
var fa = (r) => {
  const e = r.balanceRequirements.map(
    (t) => {
      if (t.type === "ERC20" && t.sufficient) {
        return {
          ...t,
          sufficient: false,
          delta: {
            balance: t.required.balance,
            formattedBalance: t.required.formattedBalance
          }
        };
      }
      return t;
    }
  );
  return {
    sufficient: false,
    balanceRequirements: e
  };
};
var qr = async (r, e, t, o, n, a, i, s, c) => {
  const p = !i || t && s ? fa(a) : a;
  const u = await k(
    r,
    "Total time to run the routing calculator",
    Gr(
      r,
      e,
      p,
      o,
      c
    )
  );
  s?.({
    sufficient: t,
    transactionRequirements: n,
    router: {
      availableRoutingOptions: o,
      routingOutcome: u
    }
  });
  return u;
};
var le = async (r, e, t, o, n, a, i, s = false) => {
  const c = await (await e.getSigner()).getAddress();
  let p = ht(t);
  const u = pr(
    e,
    c,
    p
  );
  const g = mr(
    e,
    c,
    p
  );
  const f = fr(
    e,
    c,
    p
  );
  const R = await k(
    r,
    "Time to calculate token allowances",
    Promise.all([u, g, f])
  );
  const C = dr(
    R[0],
    R[1],
    R[2]
  );
  let E = null;
  if (o) {
    E = await k(
      r,
      "Time to run gas calculator",
      wr(e, C, o)
    );
    if (E !== null) {
      p.push(E);
      p = ht(p);
    }
  }
  const T = await k(
    r,
    "Time to run balance checks",
    yr(r, e, c, p, true)
  );
  const { sufficient: y } = T;
  const I = T.balanceRequirements;
  const P = await k(
    r,
    "Time to fetch available routing options",
    kr(r, e)
  );
  if (n?.onRamp === false) P.onRamp = false;
  if (n?.swap === false) P.swap = false;
  if (n?.bridge === false) P.bridge = false;
  if (a) {
    qr(
      r,
      c,
      y,
      P,
      I,
      T,
      s,
      a,
      i
    );
    return {
      sufficient: y,
      transactionRequirements: I
    };
  }
  if (y) {
    return {
      sufficient: y,
      transactionRequirements: I
    };
  }
  const v = await qr(
    r,
    c,
    y,
    P,
    I,
    T,
    s,
    a,
    i
  );
  return {
    sufficient: y,
    transactionRequirements: I,
    router: {
      availableRoutingOptions: P,
      routingOutcome: v
    }
  };
};

// src/smartCheckout/buy/buy.ts
import {
  constants as wa,
  OrderStatusName as Pa
} from "@imtbl/orderbook";
import { track as Sa } from "@imtbl/metrics";

// src/transaction/transaction.ts
function St(r) {
  return r?.ethereumProvider?.isPassport === true;
}
function Ra(r) {
  return St(r);
}
var Ca = async (r, e) => {
  const t = e;
  const { chainId: o } = await r.getNetwork();
  if (!Qt(Number(o))) return t;
  if (typeof t.gasPrice !== "undefined") return t;
  if (Ra(r)) {
    t.gasPrice = BigInt(0);
  } else {
    t.maxFeePerGas = it.maxFeePerGas;
    t.maxPriorityFeePerGas = it.maxPriorityFeePerGas;
  }
  return t;
};
var kt = (r) => {
  if (r.code === "INSUFFICIENT_FUNDS") {
    return new m(
      r.message,
      "INSUFFICIENT_FUNDS",
      { error: r }
    );
  }
  if (r.code === "ACTION_REJECTED") {
    return new m(
      r.message,
      "USER_REJECTED_REQUEST_ERROR",
      { error: r }
    );
  }
  return new m(
    r.message,
    "TRANSACTION_FAILED",
    { error: r }
  );
};
var U = async (r, e) => {
  try {
    const t = await r.getSigner();
    const o = await Ca(r, e);
    const n = await t.sendTransaction(o);
    return {
      transactionResponse: n
    };
  } catch (t) {
    throw kt(t);
  }
};

// src/smartCheckout/actions/signActions.ts
var Ze = async (r, e) => {
  let t = [];
  try {
    const o = await Promise.all(
      e.map((n) => U(r, n))
    );
    t = await Promise.all(o.map((n) => n.transactionResponse.wait()));
  } catch (o) {
    throw new m(
      "An error occurred while executing the approval transaction",
      "EXECUTE_APPROVAL_TRANSACTION_ERROR",
      { error: o }
    );
  }
  for (const o of t) {
    if (o?.status === 0) {
      return {
        type: "FAILED",
        transactionHash: o.hash,
        reason: "Approval transaction failed and was reverted"
      };
    }
  }
  return {
    type: "SUCCESS"
  };
};
var Ye = async (r, e) => {
  let t = [];
  try {
    const o = await Promise.all(e.map(
      (n) => U(r, n)
    ));
    t = await Promise.all(o.map((n) => n.transactionResponse.wait()));
  } catch (o) {
    throw new m(
      "An error occurred while executing the fulfillment transaction",
      "EXECUTE_FULFILLMENT_TRANSACTION_ERROR",
      { error: o }
    );
  }
  for (const o of t) {
    if (o?.status === 0) {
      return {
        type: "FAILED",
        transactionHash: o.hash,
        reason: "Fulfillment transaction failed and was reverted"
      };
    }
  }
  return {
    type: "SUCCESS"
  };
};
var jr = async (r, e) => {
  try {
    const t = await (await r.getSigner()).signTypedData(
      e.unsignedMessage.domain,
      e.unsignedMessage.types,
      e.unsignedMessage.value
    );
    return {
      orderComponents: e.orderComponents,
      orderHash: e.orderHash,
      signedMessage: t
    };
  } catch (t) {
    throw new m(
      "An error occurred while signing the message",
      "SIGN_MESSAGE_ERROR",
      { error: t }
    );
  }
};

// src/smartCheckout/actions/getUnsignedActions.ts
import {
  TransactionPurpose as Je,
  ActionType as $e,
  SignablePurpose as Ia
} from "@imtbl/orderbook";
var Vr = async (r) => {
  let e = [];
  let t = [];
  const o = [];
  const n = [];
  for (const a of r) {
    if (a.type !== $e.TRANSACTION) continue;
    if (a.purpose === Je.APPROVAL) {
      o.push(a.buildTransaction());
    }
    if (a.purpose === Je.FULFILL_ORDER) {
      n.push(a.buildTransaction());
    }
  }
  e = await Promise.all(o);
  t = await Promise.all(n);
  return {
    approvalTransactions: e,
    fulfillmentTransactions: t
  };
};
var Kr = async (r) => {
  let e = [];
  const t = [];
  for (const o of r) {
    if (o.type !== $e.TRANSACTION) continue;
    if (o.purpose === Je.APPROVAL) {
      t.push(o.buildTransaction());
    }
  }
  e = await Promise.all(t);
  return e;
};
var Nt = async (r) => {
  let e = [];
  const t = [];
  for (const o of r) {
    if (o.type !== $e.TRANSACTION) continue;
    if (o.purpose === Je.FULFILL_ORDER) {
      t.push(o.buildTransaction());
    }
  }
  e = await Promise.all(t);
  return e;
};
var Hr = (r, e, t) => {
  let o;
  for (const n of t) {
    if (n.type !== $e.SIGNABLE) continue;
    if (n.purpose === Ia.CREATE_LISTING) {
      o = {
        domain: n.message.domain,
        types: n.message.types,
        value: n.message.value
      };
    }
  }
  if (!o) return void 0;
  return {
    orderHash: r,
    orderComponents: e,
    unsignedMessage: o
  };
};

// src/smartCheckout/fees/fees.ts
import { parseUnits as ha } from "ethers";
var zr = 1;
var Xe = 6;
var ya = (r, e, t = BigInt(1)) => {
  const o = r.amount;
  const n = Math.round(o.percentageDecimal * 10 ** Xe);
  const a = e * BigInt(n) / BigInt(10 ** Xe);
  return a - a % t;
};
var Aa = (r, e) => {
  const t = r.amount;
  const o = ha(t.token, e);
  return o;
};
var et = (r, e, t = 18, o = BigInt(1)) => {
  let n = BigInt(0);
  const a = BigInt(e);
  const i = a * BigInt(zr * 10 ** Xe) / BigInt(10 ** Xe);
  const s = [];
  for (const c of r) {
    let p = BigInt(0);
    if (Object.hasOwn(c.amount, "percentageDecimal")) {
      p = ya(c, a, o);
      n += p;
    } else if (Object.hasOwn(c.amount, "token")) {
      p = Aa(c, t);
      n += p;
    } else {
      throw new m(
        "Unknown fee type parsed, must be percentageDecimal or token",
        "ORDER_FEE_ERROR"
      );
    }
    if (n > i) {
      throw new m(
        `The combined fees are above the allowed maximum of ${zr * 100}%`,
        "ORDER_FEE_ERROR"
      );
    }
    if (p > 0) {
      s.push({
        amount: p.toString(),
        recipientAddress: c.recipient
      });
    }
  }
  return s;
};

// src/smartCheckout/buy/buy.ts
var ka = (r, e, t, o, n = false) => {
  switch (r) {
    case "ERC20":
      return {
        type: r,
        amount: t,
        tokenAddress: e,
        spenderAddress: o,
        isFee: n
      };
    case "NATIVE":
    default:
      return {
        type: "NATIVE",
        amount: t,
        isFee: n
      };
  }
};
var va = (r, e) => {
  if (e.length > 0) {
    return {
      type: "TRANSACTION",
      transaction: e[0]
    };
  }
  return {
    type: "GAS",
    gasToken: {
      type: "NATIVE",
      limit: BigInt(r)
    }
  };
};
var Qr = async (r, e, t, o = {
  waitFulfillmentSettlements: true
}) => {
  Sa("checkout_sdk", "buy_initiated");
  if (t.length === 0) {
    throw new m(
      "No orders were provided to the orders array. Please provide at least one order.",
      "FULFILL_ORDER_LISTING_ERROR"
    );
  }
  let n;
  let a = "";
  let i = 18;
  const s = wa.estimatedFulfillmentGasGwei;
  const c = ce(r);
  const p = Le(r);
  const u = await k(
    r,
    "Time to get the address from the provider",
    (await e.getSigner()).getAddress()
  );
  Rt();
  V(r, e, u, _(r));
  V(r, e, u, w(r));
  const { id: g, takerFees: f, fillAmount: R } = t[0];
  let C;
  try {
    n = await k(
      r,
      "Time to fetch the listing from the orderbook",
      c.getListing(g)
    );
    const { seaportContractAddress: N, chainName: te } = c.config();
    C = te;
    a = N;
  } catch (N) {
    throw new m(
      "An error occurred while getting the order listing",
      "GET_ORDER_LISTING_ERROR",
      {
        error: N,
        orderId: g
      }
    );
  }
  if (n.result.buy.length === 0) {
    throw new m(
      "An error occurred with the get order listing",
      "GET_ORDER_LISTING_ERROR",
      {
        orderId: g,
        message: "No buy side tokens found on order"
      }
    );
  }
  const E = n.result.buy[0];
  if (E.type === "ERC20") {
    const N = await k(
      r,
      "Time to get decimals of token contract for the buy token",
      p.getToken({ contractAddress: E.contractAddress, chainName: C })
    );
    if (N.result.decimals) i = N.result.decimals;
  }
  let T = [];
  if (f && f.length > 0) {
    const N = n.result.sell[0].type === "ERC721" ? BigInt(1) : BigInt(n.result.sell[0].amount);
    T = et(f, E.amount, i, N);
  }
  let y = [];
  let I = [];
  let P = [];
  const v = performance.now();
  try {
    const { actions: N } = await k(
      r,
      "Time to call fulfillOrder from the orderbook",
      c.fulfillOrder(g, u, T, R)
    );
    P = N;
    y = await k(
      r,
      "Time to construct the unsigned approval transactions",
      Kr(N)
    );
  } catch (N) {
    const te = (performance.now() - v) / 1e3;
    pt(r, "Time to call fulfillOrder from the orderbook", te);
    if (N.message.includes(Pa.EXPIRED)) {
      throw new m("Order is expired", "ORDER_EXPIRED_ERROR", { orderId: g });
    }
    if (!N.message.includes("The fulfiller does not have the balances needed to fulfill")) {
      throw new m(
        "Error occurred while trying to fulfill the order",
        "FULFILL_ORDER_LISTING_ERROR",
        {
          orderId: g,
          error: N
        }
      );
    }
  }
  try {
    I = await k(
      r,
      "Time to construct the unsigned fulfillment transactions",
      Nt(P)
    );
  } catch {
  }
  let O = BigInt("0");
  let Q = "NATIVE";
  let pe = "";
  const ee = n.result.buy;
  if (ee.length > 0) {
    switch (ee[0].type) {
      case "NATIVE":
        Q = "NATIVE";
        break;
      case "ERC20":
        Q = "ERC20";
        pe = ee[0].contractAddress;
        break;
      default:
        throw new m(
          "Purchasing token type is unsupported",
          "UNSUPPORTED_TOKEN_TYPE_ERROR",
          {
            orderId: g
          }
        );
    }
  }
  ee.forEach((N) => {
    if (N.type !== "ERC721") {
      O += BigInt(N.amount);
    }
  });
  const G = n.result.fees;
  G.forEach((N) => {
    O += BigInt(N.amount);
  });
  if (n.result.sell[0].type === "ERC1155" && R) {
    O = O * BigInt(R) / BigInt(n.result.sell[0].amount);
  }
  const rt = [
    ka(Q, pe, O, a)
  ];
  const K = await k(
    r,
    "Total time running smart checkout",
    le(
      r,
      e,
      rt,
      va(
        s,
        I
      )
    )
  );
  if (K.sufficient) {
    const N = await Ze(e, y);
    if (N.type === "FAILED") {
      return {
        status: "FAILED",
        transactionHash: N.transactionHash,
        reason: N.reason,
        smartCheckoutResult: K
      };
    }
    try {
      if (I.length === 0) {
        I = await Nt(P);
      }
    } catch (H) {
      throw new m(
        "Error fetching fulfillment transaction",
        "FULFILL_ORDER_LISTING_ERROR",
        { error: H }
      );
    }
    if (o.waitFulfillmentSettlements) {
      const H = await Ye(e, I);
      if (H.type === "FAILED") {
        return {
          status: "FAILED",
          transactionHash: H.transactionHash,
          reason: H.reason,
          smartCheckoutResult: K
        };
      }
      return {
        status: "SUCCESS",
        smartCheckoutResult: K
      };
    }
    let te;
    try {
      const H = await Promise.all(I.map(
        (ot) => U(e, ot)
      ));
      te = H.map((ot) => ot.transactionResponse);
    } catch (H) {
      throw new m(
        "An error occurred while executing the fulfillment transaction",
        "EXECUTE_FULFILLMENT_TRANSACTION_ERROR",
        {
          message: H.message
        }
      );
    }
    return {
      status: "FULFILLMENTS_UNSETTLED",
      smartCheckoutResult: K,
      transactions: te
    };
  }
  return {
    status: "INSUFFICIENT_FUNDS",
    smartCheckoutResult: K
  };
};

// src/smartCheckout/cancel/cancel.ts
var _a = async (r, e, t, o, n) => {
  let a;
  if (o.length === 0) {
    throw new m(
      "No orderIds were provided to the orderIds array. Please provide at least one orderId.",
      "CANCEL_ORDER_LISTING_ERROR"
    );
  }
  const i = o[0];
  try {
    const c = await k(
      r,
      "Time to get the address from the provider",
      (await t.getSigner()).getAddress()
    );
    const p = await k(
      r,
      "Time to get the cancel order from the orderbook",
      e.cancelOrdersOnChain(
        [i],
        c
      )
    );
    a = await p.cancellationAction.buildTransaction();
  } catch (c) {
    throw new m(
      "An error occurred while cancelling the order listing",
      "CANCEL_ORDER_LISTING_ERROR",
      {
        orderId: i,
        error: c
      }
    );
  }
  if (n) {
    const c = await Ye(t, [a]);
    if (c.type === "FAILED") {
      return {
        status: "FAILED",
        transactionHash: c.transactionHash,
        reason: c.reason
      };
    }
    return {
      status: "SUCCESS"
    };
  }
  let s;
  try {
    const c = await Promise.all([a].map(
      (p) => U(t, p)
    ));
    s = c.map((p) => p.transactionResponse);
  } catch (c) {
    throw new m(
      "An error occurred while executing the fulfillment transaction",
      "EXECUTE_FULFILLMENT_TRANSACTION_ERROR",
      {
        message: c.message
      }
    );
  }
  return {
    status: "FULFILLMENTS_UNSETTLED",
    transactions: s
  };
};
var Oa = async (r, e, t) => {
  try {
    const o = await e.getSigner();
    const n = await o.getAddress();
    const { signableAction: a } = await r.prepareOrderCancellations(t);
    const i = await o.signTypedData(
      a.message.domain,
      a.message.types,
      a.message.value
    );
    const { result: s } = await r.cancelOrders(t, n, i);
    const c = [];
    const p = [];
    const u = [];
    for (const g of s.successful_cancellations) {
      c.push({
        orderId: g
      });
    }
    for (const g of s.failed_cancellations) {
      p.push({
        orderId: g.order,
        reason: g.reason_code
      });
    }
    for (const g of s.pending_cancellations) {
      u.push({
        orderId: g
      });
    }
    return {
      successfulCancellations: c,
      failedCancellations: p,
      pendingCancellations: u
    };
  } catch (o) {
    throw new m(
      "An error occurred while cancelling the order listing",
      "CANCEL_ORDER_LISTING_ERROR",
      {
        orderIds: t,
        error: o
      }
    );
  }
};
var Zr = async (r, e, t, o = {
  waitFulfillmentSettlements: true,
  useGaslessCancel: false
}) => {
  const n = ce(r);
  if (o.useGaslessCancel) {
    return await Oa(n, e, t);
  }
  return await _a(
    r,
    n,
    e,
    t,
    o.waitFulfillmentSettlements ?? true
  );
};

// src/smartCheckout/itemRequirements/itemRequirements.ts
import { parseUnits as Yr } from "ethers";
async function Jr(r, e) {
  const t = [];
  e.forEach((a) => {
    if (a.type === "ERC20") {
      const { tokenAddress: i } = a;
      t.push(nr(i, W, r).decimals());
    }
  });
  const o = await Promise.all(t);
  const n = e.map((a, i) => {
    if (a.type === "NATIVE") {
      return {
        ...a,
        amount: Yr(a.amount, 18)
      };
    }
    if (a.type === "ERC20") {
      return {
        ...a,
        amount: Yr(a.amount, o[i])
      };
    }
    return a;
  });
  return n;
}

// src/smartCheckout/sell/sell.ts
import { Contract as Ba, parseUnits as Ma } from "ethers";
import {
  constants as ba
} from "@imtbl/orderbook";
import { track as La } from "@imtbl/metrics";
var Da = (r, e, t) => ({
  type: "ERC721",
  id: r,
  contractAddress: e,
  spenderAddress: t
});
var Wa = (r, e, t, o) => ({
  type: "ERC1155",
  id: r,
  contractAddress: e,
  spenderAddress: t,
  amount: BigInt(o)
});
var Fa = (r, e = 18) => {
  const t = Ma(r.amount, e);
  if (r.type === "NATIVE") {
    return {
      type: "NATIVE",
      amount: t.toString()
    };
  }
  return {
    type: "ERC20",
    amount: t.toString(),
    contractAddress: r.tokenAddress
  };
};
var $r = async (r, e, t) => {
  let o;
  let n;
  let a = "";
  La("checkout_sdk", "sell_initiated");
  if (t.length === 0) {
    throw new m(
      "No orders were provided to the orders array. Please provide at least one order.",
      "PREPARE_ORDER_LISTING_ERROR"
    );
  }
  const {
    buyToken: i,
    sellToken: s,
    makerFees: c,
    orderExpiry: p
  } = t[0];
  let u = 18;
  if (i.type === "ERC20") {
    const E = new Ba(
      i.tokenAddress,
      JSON.stringify(W),
      e
    );
    u = await k(
      r,
      "Time to get decimals of token contract for the buy token",
      E.decimals()
    );
  }
  const g = Fa(i, u);
  const f = "type" in s;
  try {
    const E = await k(
      r,
      "Time to get the address from the provider",
      (await e.getSigner()).getAddress()
    );
    o = ce(r);
    const { seaportContractAddress: T } = o.config();
    a = T;
    const y = f && s.type === "ERC1155" ? {
      type: "ERC1155",
      contractAddress: s.collectionAddress,
      tokenId: s.id,
      amount: s.amount
    } : {
      type: "ERC721",
      contractAddress: s.collectionAddress,
      tokenId: s.id
    };
    n = await k(
      r,
      "Time to prepare the listing from the orderbook",
      o.prepareListing({
        makerAddress: E,
        buy: g,
        sell: y,
        orderExpiry: p
      })
    );
  } catch (E) {
    throw new m(
      "An error occurred while preparing the listing",
      "PREPARE_ORDER_LISTING_ERROR",
      {
        error: E,
        id: s.id,
        collectionAddress: s.collectionAddress
      }
    );
  }
  const R = [];
  if (f && s.type === "ERC1155") {
    const E = Wa(
      s.id,
      s.collectionAddress,
      a,
      s.amount
    );
    R.push(E);
  } else {
    const E = Da(s.id, s.collectionAddress, a);
    R.push(E);
  }
  let C;
  if (!At(e)) {
    C = await k(
      r,
      "Total time running smart checkout",
      le(
        r,
        e,
        R,
        {
          type: "GAS",
          gasToken: {
            type: "NATIVE",
            limit: BigInt(ba.estimatedFulfillmentGasGwei)
          }
        }
      )
    );
  } else {
    C = { sufficient: true, transactionRequirements: [] };
  }
  if (C.sufficient) {
    const E = await Vr(n.actions);
    const T = await Ze(e, E.approvalTransactions);
    if (T.type === "FAILED") {
      return {
        status: "FAILED",
        transactionHash: T.transactionHash,
        reason: T.reason,
        smartCheckoutResult: C
      };
    }
    const y = Hr(
      n.orderHash,
      n.orderComponents,
      n.actions
    );
    if (!y) {
      throw new m(
        "The unsigned message is missing after preparing the listing",
        "SIGN_MESSAGE_ERROR",
        {
          id: s.id,
          collectionAddress: s.collectionAddress
        }
      );
    }
    const I = await jr(
      e,
      y
    );
    let P = "";
    const v = {
      orderComponents: I.orderComponents,
      orderHash: I.orderHash,
      orderSignature: I.signedMessage,
      makerFees: []
    };
    if (c !== void 0) {
      let O = BigInt(1);
      if (f && s.type === "ERC1155") O = BigInt(s.amount);
      const Q = et(c, g.amount, u, O);
      if (Q.length !== c.length) {
        throw new m(
          "One of the fees is too small, must be greater than 0.000001",
          "CREATE_ORDER_LISTING_ERROR"
        );
      }
      v.makerFees = Q;
    }
    try {
      const O = await o.createListing(v);
      P = O.result.id;
    } catch (O) {
      throw new m(
        "An error occurred while creating the listing",
        "CREATE_ORDER_LISTING_ERROR",
        {
          error: O,
          collectionId: s.id,
          collectionAddress: s.collectionAddress
        }
      );
    }
    return {
      status: "SUCCESS",
      orderIds: [P],
      smartCheckoutResult: C
    };
  }
  return {
    status: "INSUFFICIENT_FUNDS",
    smartCheckoutResult: C
  };
};

// src/swap/swap.ts
import { parseUnits as Xr } from "ethers";
var _t = async (r, e, t, o, n, a, i, s, c) => {
  if (!t.address || t.decimals === 0) {
    throw new m(
      "fromToken address or decimals is missing.",
      "MISSING_PARAMS"
    );
  }
  if (!o.address || o.decimals === 0) {
    throw new m(
      "toToken address or decimals is missing.",
      "MISSING_PARAMS"
    );
  }
  if (n && a) {
    throw new m(
      "Only one of fromAmount or toAmount can be provided.",
      "MISSING_PARAMS"
    );
  }
  if (!n && !a) {
    throw new m(
      "fromAmount or toAmount must be provided.",
      "MISSING_PARAMS"
    );
  }
  const p = w(r);
  const u = await se(p, r);
  const g = await (await e.getSigner()).getAddress();
  if (n) {
    return u.getUnsignedSwapTxFromAmountIn(
      g,
      t.address,
      o.address,
      BigInt(Xr(n, t.decimals)),
      i,
      s,
      c
    );
  }
  return u.getUnsignedSwapTxFromAmountOut(
    g,
    t.address,
    o.address,
    BigInt(Xr(a, o.decimals)),
    i,
    s,
    c
  );
};
var eo = async (r, e, t, o, n, a, i, s, c) => {
  const p = await _t(
    r,
    e,
    t,
    o,
    n,
    a,
    i,
    s,
    c
  );
  if (p.approval) {
    const f = await U(e, p.approval.transaction);
    const R = await f.transactionResponse.wait();
    if (R?.status === 0) {
      throw new m(
        "Approval transaction failed and was reverted",
        "APPROVAL_TRANSACTION_FAILED"
      );
    }
  }
  const u = await U(e, p.swap.transaction);
  const g = await u.transactionResponse.wait();
  if (g?.status === 0) {
    throw new m(
      "Swap transaction failed and was reverted",
      "TRANSACTION_FAILED"
    );
  }
  return {
    swapReceipt: g,
    quote: p.quote,
    swap: p.swap
  };
};

// src/wallet/wallet.ts
async function to(r) {
  const e = [];
  const t = r.exclude?.map((n) => n.walletProviderName) ?? [];
  let o = Object.values(fe);
  if (t.length !== 0) {
    o = o.filter((n) => !t.includes(n));
  }
  for (const n of o) {
    e.push({
      walletProviderName: n
    });
  }
  return {
    wallets: e
  };
}

// src/riskAssessment/riskAssessment.ts
import ja from "axios";
var Ot = async (r, e) => {
  const t = Object.fromEntries(
    r.map((n) => [n.toLowerCase(), { sanctioned: false }])
  );
  const o = await e.remote.getConfig("riskAssessment");
  if (!o?.enabled) {
    return t;
  }
  try {
    const n = o?.levels.map((i) => i.toLowerCase()) ?? [];
    const a = await ja.post(
      `${q[e.environment]}/v1/sanctions/check`,
      {
        addresses: r
      }
    );
    for (const i of a.data) {
      t[i.address.toLowerCase()].sanctioned = n.includes(
        i.risk.toLowerCase()
      );
    }
    return t;
  } catch (n) {
    console.error("Error fetching risk assessment", n);
    return t;
  }
};
var xt = (r, e) => {
  if (e) {
    return r[e.toLowerCase()].sanctioned;
  }
  return Object.values(r).some((t) => t.sanctioned);
};

// src/sdk.ts
var Ka = {
  baseConfig: {
    environment: Va.SANDBOX
  },
  passport: void 0
};
var Bt = class {
  readOnlyProviders;
  httpClient;
  config;
  fiatRampService;
  availability;
  passport;
  /**
   * Constructs a new instance of the CheckoutModule class.
   * @param {CheckoutModuleConfiguration} [config=SANDBOX_CONFIGURATION] - The configuration object for the CheckoutModule.
   */
  constructor(e = Ka) {
    this.httpClient = new ue(e);
    this.config = new ye(e, this.httpClient);
    this.fiatRampService = new Me(this.config);
    this.readOnlyProviders = /* @__PURE__ */ new Map();
    this.availability = Ne(
      this.config.isDevelopment,
      this.config.isProduction
    );
    this.passport = e.passport;
    F.getInstance().initialise();
  }
  /**
   * Loads the widgets bundle and initiates the widgets factory.
   * @param {WidgetsInit} init - The initialisation parameters for loading the widgets bundle and applying configuration
   * @returns {Promise<ImmutableCheckoutWidgets.WidgetsFactory>} A promise that resolves to the widgets factory instance
   *                                                             that can be used to create and manage widgets
   * @throws {CheckoutError} When the widgets script fails to load
   */
  async widgets(e) {
    const t = this;
    const o = me();
    try {
      const n = `https://cdn.jsdelivr.net/npm/@imtbl/checkout-widgets@${me()}/dist/browser/index.js`;
      const a = await import(
        /* webpackIgnore: true */
        n
      );
      if (a && a.WidgetsFactory) {
        return new a.WidgetsFactory(t, e.config);
      }
      throw new Error(`WidgetsFactory not found in loaded module for version: ${o}`);
    } catch (n) {
      throw new m(
        "Failed to load widgets script",
        "WIDGETS_SCRIPT_LOAD_ERROR",
        { error: n }
      );
    }
  }
  /**
   * Creates a provider using the given parameters.
   * @param {CreateProviderParams} params - The parameters for creating the provider.
   * @returns {Promise<CreateProviderResult>} A promise that resolves to the created provider.
   */
  async createProvider(e) {
    return await sr(
      e.walletProviderName,
      this.passport
    );
  }
  /**
   * Returns a list of EIP-6963 injected providers and their metadata.
   * @returns {readonly EIP6963ProviderDetail[]} A readonly array of injected providers and their metadata.
   */
  getInjectedProviders() {
    return F.getInstance().getProviders();
  }
  /**
   * Finds an injected provider by its RDNS.
   * @param {{rdns: string}} args - The parameters for finding the injected provider.
   * @returns {EIP6963ProviderDetail | undefined} - The found provider and metadata or undefined.
   */
  findInjectedProvider(e) {
    return F.getInstance().findProvider(e);
  }
  /**
   * Subscribes to changes in the injected providers.
   * @param {(providers: EIP6963ProviderDetail[]) => void} listener - The listener to be called when the injected providers change.
   * @returns {() => void} - A function to unsubscribe the listener.
   */
  onInjectedProvidersChange(e) {
    return F.getInstance().subscribe(e);
  }
  /**
   * Clears all registered injected providers and their subscriptions.
   * @returns {void} This method doesn't return a value
   */
  clearInjectedProviders() {
    return F.getInstance().clear();
  }
  /**
   * Checks if a wallet is connected to the specified provider.
   * @param {CheckConnectionParams} params - The parameters for checking the wallet connection.
   * @returns {Promise<CheckConnectionResult>} - A promise that resolves to the result of the check.
   */
  async checkIsWalletConnected(e) {
    const t = await b(
      this.config,
      e.provider,
      {
        allowMistmatchedChainId: true,
        allowUnsupportedProvider: true
      }
    );
    return $t(t);
  }
  /**
   * Fetches the risk assessment for the given addresses.
   * @param {string[]} addresses - The addresses to assess.
   * @returns {Promise<AssessmentResult>} - A promise that resolves to the risk assessment result.
   */
  async getRiskAssessment(e) {
    return await Ot(e, this.config);
  }
  /**
   * Helper method that checks if given risk assessment results contain sanctioned addresses.
   * @param {AssessmentResult} assessment - Risk assessment to analyse.
   * @param {string} [address] - If defined, only sanctions for the given address will be checked.
   * @returns {boolean} - Result of the check.
   */
  checkIsAddressSanctioned(e, t) {
    return xt(e, t);
  }
  /**
   * Connects to a blockchain network using the specified provider.
   * @param {ConnectParams} params - The parameters for connecting to the network.
   * @returns {Promise<ConnectResult>} A promise that resolves to an object containing the provider and network information.
   * @throws {Error} If the provider is not valid or if there is an error connecting to the network.
   */
  async connect(e) {
    const t = await b(
      this.config,
      e.provider,
      {
        allowUnsupportedProvider: true,
        allowMistmatchedChainId: true
      }
    );
    if (e.requestWalletPermissions && !St(t)) {
      await er(t);
    } else {
      await Xt(t);
    }
    return t;
  }
  /**
   * Adds the network for the current wallet provider.
   * @param {AddNetworkParams} params - The parameters for adding the network.
   * @returns {Promise<any>} - A promise that resolves to the result of adding the network.
   * @throws {CheckoutError} When the network cannot be added to the wallet
   */
  async addNetwork(e) {
    const t = await b(
      this.config,
      e.provider,
      {
        allowUnsupportedProvider: true,
        allowMistmatchedChainId: true
      }
    );
    const o = await dt(
      this.config.networkMap,
      t,
      e.chainId
    );
    return o;
  }
  /**
   * Switches the network for the current wallet provider.
   * @param {SwitchNetworkParams} params - The parameters for switching the network.
   * @returns {Promise<SwitchNetworkResult>} - A promise that resolves to the result of switching the network.
   */
  async switchNetwork(e) {
    const t = await b(
      this.config,
      e.provider,
      {
        allowUnsupportedProvider: true,
        allowMistmatchedChainId: true
      }
    );
    const o = await Ht(
      this.config,
      t,
      e.chainId
    );
    return o;
  }
  /**
   * Retrieves the token information given the token address. This function makes RPC calls to
   * ERC20 contracts to fetch the main contract information (e.g. symbol).
   * @param {GetTokenInfoParams} params - The parameters for retrieving the token information.
   * @returns {Promise<TokenInfo>} - A promise that resolves to the token info request.
   */
  async getTokenInfo(e) {
    return await Be(e.provider, e.tokenAddress);
  }
  /**
   * Retrieves the balance of a wallet address.
   * @param {GetBalanceParams} params - The parameters for retrieving the balance.
   * @returns {Promise<GetBalanceResult>} - A promise that resolves to the balance result.
   */
  async getBalance(e) {
    const t = await b(
      this.config,
      e.provider
    );
    if (!e.tokenAddress || e.tokenAddress === "") {
      return await ft(
        this.config,
        t,
        e.walletAddress
      );
    }
    return await Et(
      t,
      e.walletAddress,
      e.tokenAddress
    );
  }
  /**
   * Retrieves the balances of all tokens for a given wallet address on a specific chain.
   * @param {GetAllBalancesParams} params - The parameters for retrieving the balances.
   * @returns {Promise<GetAllBalancesResult>} - A promise that resolves to the result of retrieving the balances.
   */
  async getAllBalances(e) {
    const t = !e.provider || "ethereumProvider" in e.provider ? e.provider : new D(e.provider);
    return V(
      this.config,
      t,
      e.walletAddress,
      e.chainId
    );
  }
  /**
   * Retrieves the supported networks based on the provided parameters.
   * @param {GetNetworkAllowListParams} params - The parameters for retrieving the network allow list.
   * @returns {Promise<GetNetworkAllowListResult>} - A promise that resolves to the network allow list result.
   */
  async getNetworkAllowList(e) {
    return await $(this.config, e);
  }
  /**
   * Retrieves the supported tokens based on the provided parameters.
   * @param {GetTokenAllowListParams} params - The parameters for retrieving the token allow list.
   * @returns {Promise<GetTokenAllowListResult>} - A promise that resolves to the token allow list result.
   */
  async getTokenAllowList(e) {
    return await z(this.config, e);
  }
  /**
   * Retrieves the default supported wallets based on the provided parameters.
   * @param {GetWalletAllowListParams} params - The parameters for retrieving the wallet allow list.
   * @returns {Promise<GetWalletAllowListResult>} - A promise that resolves to the wallet allow list result.
   */
  async getWalletAllowList(e) {
    return await to(e);
  }
  /**
   * Sends a transaction using the specified provider and transaction parameters.
   * @param {SendTransactionParams} params - The parameters for sending the transaction.
   * @returns {Promise<SendTransactionResult>} A promise that resolves to the result of the transaction.
   */
  async sendTransaction(e) {
    const t = await b(
      this.config,
      e.provider,
      {
        allowUnsupportedProvider: true,
        allowMistmatchedChainId: true
      }
    );
    return await U(t, e.transaction);
  }
  /**
   * Wraps a WrappedBrowserProvider call to validate the provider and handle errors.
   * @param {BrowserProvider} browserProvider - The provider to connect to the network.
   * @param {(browserProvider: WrappedBrowserProvider) => Promise<T>)} block - The block executing the provider call.
   * @returns {Promise<T>} Returns the result of the provided block param.
   */
  async providerCall(e, t) {
    const o = await b(
      this.config,
      e,
      {
        allowUnsupportedProvider: true,
        allowMistmatchedChainId: true
      }
    );
    try {
      return await t(o);
    } catch (n) {
      throw kt(n);
    }
  }
  /**
   * Retrieves network information using the specified provider.
   * @param {GetNetworkParams} params - The parameters for retrieving network information.
   * @returns {Promise<NetworkInfo>} A promise that resolves to the network information.
   */
  async getNetworkInfo(e) {
    const t = await b(
      this.config,
      e.provider,
      {
        allowUnsupportedProvider: true,
        allowMistmatchedChainId: true
      }
    );
    return await he(this.config, t);
  }
  /**
   * Determines the requirements for performing a buy.
   * @param {BuyParams} params - The parameters for the buy.
   * @returns {Promise<BuyResult>} A promise that resolves to the buy transaction requirements
   * @deprecated Please use orderbook.fulfillOrder or orderbook.fulfillBulkOrders instead. The smartCheckout
   * method can still be used to ensure the transaction requirements are met before preparing the order fulfillment
   */
  async buy(e) {
    if (e.orders.length > 1) {
      console.warn(
        "This endpoint currently only processes the first order in the array."
      );
    }
    const t = await b(
      this.config,
      e.provider
    );
    return await Qr(
      this.config,
      t,
      e.orders,
      e.overrides
    );
  }
  /**
   * Determines the requirements for performing a sell.
   * @param {SellParams} params - The parameters for the sell.
   * @returns {Promise<SellResult>} A promise that resolves to the sell transaction requirements
   * Only currently actions the first order in the array until we support batch processing.
   * Only currently actions the first fee in the fees array of each order until we support multiple fees.
   * @deprecated Please use orderbook.prepareListing or orderbook.prepareBulkListing instead. The smartCheckout
   * method can still be used to ensure the transaction requirements are met before preparing the listing
   */
  async sell(e) {
    if (e.orders.length > 1) {
      console.warn(
        "This endpoint currently only processes the first order in the array."
      );
    }
    const t = await b(
      this.config,
      e.provider
    );
    return await $r(this.config, t, e.orders);
  }
  /**
   * Cancels a sell.
   * @param {CancelParams} params - The parameters for the cancel.
   * @returns {Promise<CancelResult>} A promise that resolves to the cancel transaction result
   * @deprecated Please use orderbook.prepareOrderCancellations instead.
   */
  async cancel(e) {
    console.warn(
      "This endpoint currently only processes the first order in the array."
    );
    const t = await b(
      this.config,
      e.provider
    );
    return await Zr(
      this.config,
      t,
      e.orderIds,
      e.overrides
    );
  }
  /**
   * Determines the transaction requirements to complete a purchase.
   * This includes checking token approvals, native currency balance,
   * and calculating the optimal route for completing the transaction.
   * @param {SmartCheckoutParams} params - The parameters for smart checkout.
   * @returns {Promise<SmartCheckoutResult>} A promise that resolves to the transaction requirements including:
   * - Required token approvals
   * - Required native currency balance
   * - Suggested transaction route
   * - Estimated gas costs
   * @throws {CheckoutError} When item requirements cannot be mapped or checkout validation fails
   */
  async smartCheckout(e) {
    const t = await b(
      this.config,
      e.provider
    );
    let o = [];
    try {
      o = await Jr(
        t,
        e.itemRequirements
      );
    } catch (n) {
      throw new m(
        "Failed to map item requirements",
        "ITEM_REQUIREMENTS_ERROR",
        { error: n }
      );
    }
    return await le(
      this.config,
      t,
      o,
      e.transactionOrGasAmount,
      e.routingOptions,
      e.onComplete,
      e.onFundingRoute,
      e.fundingRouteFullAmount
    );
  }
  /**
   * Checks if the given object is a WrappedBrowserProvider.
   * @param {BrowserProvider} browserProvider - The object to check.
   * @returns {boolean} - True if the object is a WrappedBrowserProvider, false otherwise.
   */
  static isWrappedBrowserProvider(e) {
    return cr(e);
  }
  /**
   * Estimates the gas required for a swap or bridge transaction.
   * @param {GasEstimateParams} params - The parameters for the gas estimation.
   * @returns {Promise<GasEstimateSwapResult | GasEstimateBridgeToL2Result>} - A promise that resolves to the gas estimation result.
   */
  async gasEstimate(e) {
    this.readOnlyProviders = await Fe(
      this.config,
      this.readOnlyProviders
    );
    return await ir(
      e,
      this.readOnlyProviders,
      this.config
    );
  }
  /**
   * Creates and returns a URL for the fiat ramp widget.
   * @param {FiatRampParams} params - The parameters for creating the url.
   * @returns {Promise<string>} - A promise that resolves to a string url.
   */
  async createFiatRampUrl(e) {
    let t;
    let o = "IMX";
    let n;
    const a = "request" in e.browserProvider ? new D(e.browserProvider) : e.browserProvider;
    const i = await (await a.getSigner()).getAddress();
    const s = a.ethereumProvider?.isPassport || false;
    if (s && e.passport) {
      const g = await e.passport.getUserInfo();
      n = g?.email;
    }
    const c = await z(this.config, {
      type: "onramp"
    });
    const p = c.tokens?.find((g) => h(g.address, e.tokenAddress));
    if (p) {
      t = e.tokenAmount;
      o = p.symbol;
    }
    const u = c?.tokens?.filter((g) => g.symbol).map((g) => g.symbol);
    return await this.fiatRampService.createWidgetUrl({
      exchangeType: e.exchangeType,
      isPassport: s,
      walletAddress: i,
      tokenAmount: t,
      tokenSymbol: o,
      email: n,
      allowedTokens: u
    });
  }
  /**
   * Fetches fiat ramp fee estimations.
   * @returns {Promise<OnRampProviderFees>} - A promise that resolves to OnRampProviderFees.
   */
  async getExchangeFeeEstimate() {
    return await this.fiatRampService.feeEstimate();
  }
  /**
   * Fetches Swap widget availability.
   * @returns {Promise<boolean>} - A promise that resolves to a boolean.
   */
  async isSwapAvailable() {
    return this.availability.checkDexAvailability();
  }
  /**
   * Fetches a quote and then performs the approval and swap transaction.
   * @param {SwapParams} params - The parameters for the swap.
   * @returns {Promise<SwapResult>} - A promise that resolves to the swap result (swap tx, swap tx receipt, quote used in the swap).
   */
  async swap(e) {
    const t = await b(
      this.config,
      e.provider
    );
    return eo(
      this.config,
      t,
      e.fromToken,
      e.toToken,
      e.fromAmount,
      e.toAmount,
      e.slippagePercent,
      e.maxHops,
      e.deadline
    );
  }
  /**
   * Fetches a quote for the swap.
   * @param {SwapParams} params - The parameters for the swap.
   * @returns {Promise<SwapQuoteResult>} - A promise that resolves to the swap quote result.
   */
  async swapQuote(e) {
    const t = await b(
      this.config,
      e.provider
    );
    return _t(
      this.config,
      t,
      e.fromToken,
      e.toToken,
      e.fromAmount,
      e.toAmount,
      e.slippagePercent,
      e.maxHops,
      e.deadline
    );
  }
};

// src/blockExplorer/blockExplorer.ts
var tt = class {
  /**
   * Returns the link to the transaction on Blockscout.
   * @param {ChainId} chainId - The chain ID of the network
   * @param {string} hash - The transaction hash
   * @returns {string | undefined} The URL to view the transaction on Blockscout, or undefined if the chain ID or hash is invalid
   */
  static getTransactionLink(e, t) {
    const o = oe?.[e]?.url;
    if (!o || !t) return void 0;
    return `${o}/tx/${t}`;
  }
};
export {
  Ro as AddTokensEventType,
  tt as BlockExplorerService,
  lo as BridgeEventType,
  Y as ChainId,
  nt as ChainName,
  we as ChainSlug,
  Bt as Checkout,
  ye as CheckoutConfiguration,
  m as CheckoutError,
  S as CheckoutErrorType,
  Ee as CheckoutStatus,
  mo as CommerceEventType,
  fo as CommerceFailureEventType,
  Ao as CommerceFlowType,
  go as CommerceSuccessEventType,
  Eo as CommerceUserActionEventType,
  no as ConnectEventType,
  ho as ConnectTargetLayer,
  Vt as ExchangeType,
  _e as FeeType,
  Te as FundingStepType,
  st as GasEstimateType,
  Ce as GasTokenType,
  q as IMMUTABLE_API_BASE_URL,
  ro as IMTBLWidgetEvents,
  M as ItemType,
  ge as NetworkFilterTypes,
  uo as OnRampEventType,
  po as OrchestrationEventType,
  oo as ProviderEventType,
  Co as PurchaseEventType,
  ct as RoutingOutcomeType,
  so as SaleEventType,
  co as SalePaymentTypes,
  yo as SwapDirection,
  io as SwapEventType,
  ae as TokenFilterTypes,
  Re as TransactionOrGasType,
  To as TransferEventType,
  ao as WalletEventType,
  Gt as WalletFilterTypes,
  fe as WalletProviderName,
  qt as WalletProviderRdns,
  wo as WidgetTheme,
  Io as WidgetType,
  D as WrappedBrowserProvider,
  Ot as fetchRiskAssessment,
  Ct as getGasPriceInWei,
  fn as getMetaMaskProviderDetail,
  gn as getPassportProviderDetail,
  Ie as getUnderlyingChainId,
  xt as isAddressSanctioned,
  De as metaMaskProviderInfo,
  We as passportProviderInfo,
  b as validateProvider
};
